'use strict';

app.controller('searchcontroller', ['$scope', '$location', '$window', '$http', '$cookies', 'searchservice', 'searchDataService', 'plotDataService', 'GetSpectrumIDServices', 'plotgraphservice', 'progressBarService', '$compile', '$rootScope', 'deviceDetector', '$timeout', '$routeParams', 'storeUploadService', 'DataManagementService', function ($scope, $location, $window, $http, $cookies, searchservice, searchDataService, plotDataService, GetSpectrumIDServices, plotgraphservice, progressBarService, $compile, $rootScope, deviceDetector, $timeout, $routeParams, storeUploadService, dataManagementService) {
    if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined) {
        $location.path('/login');
        return;
    }

    $rootScope.selectedWorkspaceName = $rootScope.selectedWorkspaceName == undefined || $rootScope.selectedWorkspaceName == "" ? 'Choose Workspace' : $rootScope.selectedWorkspaceName;

    $scope.showSavebtn = false;
    $scope.isUVTechSelected = false;
    $scope.isUVTechSearchResult = false;

    $scope.serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
    $scope.isKratosData = getLocalValue("isKratosData");

    $scope.pagingInfoEnegry = searchDataService.pagingInfoEnegry;
    $scope.pagingInfo = searchDataService.pagingInfo;
    $scope.viewMyDataPagingInfo = searchDataService.viewMyDataPagingInfo;
    $scope.viewTeamDataPagingInfo = searchDataService.viewTeamDataPagingInfo;
    $scope.searchTypeBasic = searchDataService.searchTypeBasic;
    if (searchDataService.techniques.length == 0) {
        var objectTechniques = getLocalValue("objectTechniques");

        angular.forEach(objectTechniques, function (value, key) {
            searchDataService.techniques.push({
                name: value,
                selected: value.toLowerCase() == 'xps' || value.toLowerCase() == 'ups' ? true : false,
                disabled: false
            })
        });
    }
    $scope.techniques = searchDataService.techniques;

    $scope.selection = searchDataService.selection;
    // spectral
    $scope.spectrals = searchDataService.spectrals;

    $scope.selectionSpectral = searchDataService.selectionSpectral;

    searchservice.getAllSavedWorkSpace($scope);

    $scope.collapsableRowsSwitchOn = searchDataService.collapsableRowsSwitchOn;

    $scope.currentTab = $scope.pagingInfo.currentTab;

    $scope.isActiveTab = function (tabIndex) {
        return tabIndex === $scope.currentTab
    };

    $scope.isActiveTab($scope.currentTab);

    $scope.onClickTab = function (tabIndex) {
        $scope.currentTab = tabIndex;
        $scope.pagingInfo.currentTab = tabIndex;
        searchDataService.pagingInfo.currentTab = tabIndex;
        if (tabIndex == 2 && $scope.viewMyDataSearchResults === undefined) {
            $scope.search();
        } else if (tabIndex == 2 && $scope.viewMyDataSearchResults.length <= 0) {
            $scope.search();
        } else if (tabIndex == 3 && $scope.viewTeamDataSearchResults === undefined) {
            $scope.search();
        } else if (tabIndex == 3 && $scope.viewTeamDataSearchResults.length <= 0) {
            $scope.search();
        }
        return tabIndex == $scope.currentTab
    };

    $scope.showAdvancedSearch = function (isAdvancedSearch) {
        $scope.searchTypeBasic = !isAdvancedSearch;
        searchDataService.searchTypeBasic = $scope.searchTypeBasic;
        if (isAdvancedSearch) {
            if ($scope.pagingInfo.keywords.length > 0) {
                $($('.keywords')[1]).focus();
                $($('.keywords')[1]).parent().siblings("label").addClass("active");
                $($('.keywords')[1]).siblings("label").addClass("active");
            } else {
                $($('.keywords')[1]).parent().siblings("label").removeClass("active");
                $($('.keywords')[1]).siblings("label").removeClass("active");
            }
        } else {
            if ($scope.pagingInfo.keywords.length > 0) {
                $('.keywords').focus();
                $('.keywords').parent().siblings("label").addClass("active");
                $('.keywords').siblings("label").addClass("active");
            } else {
                $('.keywords').parent().siblings("label").removeClass("active");
                $('.keywords').siblings("label").removeClass("active");
            }
        }
    }

    $scope.pagingInfoDate = searchDataService.pagingInfoDate;

    $("#fromDate").val($scope.pagingInfoDate.startVal);

    $("#toDate").val($scope.pagingInfoDate.endVal);

    var vm = this;
    vm.data = deviceDetector;
    vm.allData = JSON.stringify(vm.data, null, 2);
    if (vm != null) {
        $scope.deviceName = vm.data.device;
    }

    $scope.showFiguresDetailsTableHeader = 0;
    $rootScope.SearchLinkCSS = 'active';
    $rootScope.PlotGraphLinkCSS = 'disabled';
    $rootScope.SaveWorkspaceLinkCSS = '';

    $scope.UnPublishedDataSet = [];

    $scope.generateYear = function () {
        var i, yr, now = new Date();
        for (i = now.getFullYear() ; i >= 1992; i--) {

            $('.year-dropdown').append('<li year="year-' + i + '"><a>' + i + '</a></li>');
        };
    }

    $scope.generateYear();

    $scope.reset = function (event) {
        $scope.isActiveTab(1);
        $scope.currentTab = 1;

        $("#searchResultsContainer").removeClass("in");
        $("#viewMyDataSearchResultsContainer").removeClass("in");
        $("#viewTeamDataSearchResultsContainer").removeClass("in");

        $scope.searchResultMsg = "Kindly search for a dataset.";
        $scope.viewMyDataSearchResultMsg = "Kindly search for a dataset.";
        $scope.viewTeamDataSearchResultMsg = "Kindly search for a dataset.";

        $(".no-dataset-msg").show();
        $(".search-result-div").css("min-height", $(".search-result-div").siblings(".col-md-4").height());

        $scope.searchResults = [];
        $scope.viewMyDataSearchResults = [];
        $scope.viewTeamDataSearchResults = [];

        $(".input-feild-textbox").val("");
        $scope.changedField = '';
        $(".input-feild-textbox").typeahead('destroy');
        $(".input-feild-textbox").removeClass("border-red");

        $("#searchCriteriaContainer").find(".control-label").not(".spectral-region").removeClass("active");
        $("#searchCriteriaContainer").find(".control-label").find("span").not(".doi-eg").hide();
        $("#viewMyDataSearchCriteriaContainer").find(".control-label").not(".spectral-region").removeClass("active");
        $("#viewMyDataSearchCriteriaContainer").find(".control-label").find("span").not(".doi-eg").hide();
        $("#viewTeamDataSearchCriteriaContainer").find(".control-label").not(".spectral-region").removeClass("active");
        $("#viewTeamDataSearchCriteriaContainer").find(".control-label").find("span").not(".doi-eg").hide();

        $("#spectralRegion").val('survey');
        $scope.selectionSpectral = ['Survey', 'Valence Band', 'Transition', 'UNSPECIFIED'];
        $scope.selection = ['XPS', 'UPS'];
        searchDataService.selection = ['XPS', 'UPS'];
        searchDataService.selectionSpectral = ['Survey', 'Valence Band', 'Transition', 'UNSPECIFIED'];
        searchDataService.collapsableRowsSwitchOn = true;
        $scope.collapsableRowsSwitchOn = true;
        //$(".toggle-all-row-element").hide();
        $(".switch").hide();
        $(".switch > input[type='checkbox']").prop('checked', false);
        var currentDate = new Date();

        $scope.pagingInfo = {
            pageNo: 1,
            itemsPerPage: 10,
            sortBy: 'doi',
            reverse: true,
            keywords: '',
            chemicalName: '',
            hostMaterial: '',
            transition: '',
            element: '',
            authorLName: '',
            spectralRegion: '',
            startVal: '',
            endVal: '',
            fromDate: '',
            toDate: '',
            articleName: '',
            technique: '',
            doi: '',
            rangeApplied: false,
            currentTab: 1,
            casRegistryNumber: '',
            pubYear: ''
        };

        $scope.viewMyDataPagingInfo = {
            pageNo: 1,
            itemsPerPage: 10,
            sortBy: 'publicationyear',
            reverse: true
        };

        $scope.viewTeamDataPagingInfo = {
            pageNo: 1,
            itemsPerPage: 10,
            sortBy: 'publicationyear',
            reverse: true
        };

        $scope.pagingInfoEnegry = {
            startVal: '', endVal: '', min: '', max: '', options: {
                floor: '',
                ceil: '',
                step: 1
            }
        };

        $scope.pagingInfoDate = {
            startVal: '', endVal: '', min: '', max: '', options: {
                floor: '',
                ceil: '',
                step: 1
            }
        };


        searchDataService.showBackupData = false;

        //clear all array stored backups
        //searchDataService.pagingInfo = $scope.originForm;
        $scope.currentPage = 1;
        $scope.viewMyDataCurrentPage = 1;
        $scope.viewTeamDataCurrentPage = 1;

        searchDataService.currentPage = 1;
        searchDataService.viewMyDataCurrentPage = 1;
        searchDataService.viewTeamDataCurrentPage = 1;

        searchDataService.searchResultsBackup = [];
        searchDataService.viewMyDataSearchResultsBackup = [];
        searchDataService.viewTeamDataSearchResultsBackup = [];

        //Enable submt button
        $("#submitButton").removeClass("disabled");
        $("#submitButton").prop("disabled", false);
        $("#toDate").prop("disabled", true);
        //$("#submitButton").focus();
        if (event != undefined) {
            event.preventDefault();
        }

        $("html, body").animate({
            scrollTop: 0
        }, "500");
        $scope.isUVTechSelected = false;
        $scope.techniques = [];
        var objectTechniques = getLocalValue("objectTechniques");
        angular.forEach(objectTechniques, function (value, key) {
            $scope.techniques.push({
                name: value,
                selected: value.toLowerCase() == 'xps' || value.toLowerCase() == 'ups' ? true : false,
                disabled: false
            })
        });
    };

    $scope.CloseWorkSpace = function () {
        angular.element(document.getElementsByClassName("pull-right clear-all-datasets")).hide();
        $rootScope.SelectedWorkArea = null;
        //searchservice.deleteUnpublishedDataSets($scope, '', '', true);
        plotDataService.clearSpectrumIds();
        plotDataService.clearObjectIds();
        plotDataService.clearTechnique();
        plotDataService.clearDataSetDisplayString();
        plotDataService.clearSearchString();
        plotDataService.clearFiles();
        $rootScope.PlotGraphLinkCSS = 'disabled';
        angular.element(document.getElementsByClassName("plotting-area")).parent().removeClass("active").addClass("disabled");
        angular.element(document.getElementsByClassName("plotting-area")).addClass("disabled").attr("disabled", true);

        $rootScope.selectedWorkspaceName = 'Choose Workspace';

        $(".plot-chart").addClass("disabled");
        $(".plot-chart").prop("disabled", true);

        $("#searchResultsTable").find(".added-row").removeClass("added-row");
        $("#searchResultsTable").find(".add-chemical").removeClass("fa-minus remove-chemical color-red").addClass("fa-plus")
        $("#viewMyDataSearchResultsTable").find(".added-row").removeClass("added-row");
        $("#viewMyDataSearchResultsTable").find(".add-chemical").removeClass("fa-minus remove-chemical color-red").addClass("fa-plus")
        $("#viewTeamDataSearchResultsTable").find(".added-row").removeClass("added-row");
        $("#viewTeamDataSearchResultsTable").find(".add-chemical").removeClass("fa-minus remove-chemical color-red").addClass("fa-plus")

        $("#addedChemicals tbody").children().remove();
        $(".no-chemical-msg").fadeIn();
        $(".plotting-area").parent().removeClass("active").addClass("disabled");
        $(".plotting-area").addClass("disabled").attr("disabled", true);
    }

    $scope.ClearSpectrumIds = function () {
        progressBarService.showProgressBar();
        plotDataService.clearSpectrumIds();
        plotDataService.clearObjectIds();
        //searchservice.deleteUnpublishedDataSets($scope, '', '', true);
        plotDataService.clearTechnique();
        plotDataService.clearDataSetDisplayString();
        plotDataService.clearSearchString();
        plotDataService.clearFiles();
        progressBarService.hideProgressBar();

        $scope.CloseWorkSpace();
    }

    //if ($cookies.get('SessionID') != null && $cookies.get('SessionID') != 'undefined' && $cookies.get('SessionID') != '') {
    //    $scope.SessionUploadID = $cookies.get('SessionID');
    //}
    //else {
    if (!getLocalValue('isRedirectedFromPlotgraph')) {
        searchservice.getSessionID($scope);
        $scope.reset();
        $scope.searchTypeBasic = true;
        $scope.collapsableRowsSwitchOn = true;
        if (!$routeParams.mode) {
            $scope.ClearSpectrumIds();
            $rootScope.SelectedWorkArea = undefined;
        }
    }

    //searchservice.getUnpublishedFile($scope);

    $scope.unPublishedIDs = 0;
    if ($scope.unPublishedIDs == "undefined") {
        $scope.unPublishedIDs = 0;
    }

    $scope.SetWorkSpaceData = function () {

        var spectrumIdList = plotDataService.getSpectrumIds();
        //var objectIdList = plotDataService.getObjectIds();


        if (spectrumIdList != null && spectrumIdList.length > 0) {
            for (var i = 0; i < spectrumIdList.length; i++) {
                var details = plotDataService.getSpectrumId(spectrumIdList[i])
                if (details != null && details.isValidFigureData) {
                    $scope.workareaId = details.WorkAreaID;
                    $scope.SetDataSetOnLoad(details.ObjectID, details.SpectrumId, details.Technique, details.ChemicalName, details.HostMaterial, details.SpectralRegion, details.PublicationYear, details.Doi, details.FileName, details.IsCurated, details.index);
                }
            }
        }

    }

    $scope.SetWorkSpaceFileData = function () {
        var spectrumFiles = plotDataService.getFiles();
        if (spectrumFiles != null && spectrumFiles.length > 0) {
            for (var i = 0; i < spectrumFiles.length; i++) {
                var details = plotDataService.getfileByName(spectrumFiles[i])
                if (details != null && details.isValidFigureData) {
                    $scope.workareaId = details.WorkAreaID;
                    $scope.SetDataSetOnLoad(details.ObjectID, details.SpectrumId, details.Technique, details.ChemicalName, details.HostMaterial, details.SpectralRegion, details.PublicationYear, details.Doi, details.FileName, details.IsCurated, details.index);
                }
            }
        }

    }

    $scope.SetDataSetOnLoad = function (objectId, spectrumId, technique, chemicalName, hostMaterial, spectralRegion, publicationYear, doi, fileName, isCurated, index) {

        var createString;
        var selectedField = [];

        selectedField.push(doi);

        if (technique != null && technique != "") {
            selectedField.push(technique);
        }

        if (chemicalName != null && chemicalName != "") {
            selectedField.push(chemicalName);
        }

        //if (hostMaterial != null && hostMaterial != "") {
        //    selectedField.push(hostMaterial);
        //}

        if (spectralRegion != null && spectralRegion != "") {
            selectedField.push(spectralRegion);
        }

        if (publicationYear != null && publicationYear != "") {
            selectedField.push(publicationYear.split("-")[0]);
        }

        createString = selectedField.join(" - ");

        var chkTechnique = searchDataService.showBackupData == false ? $scope.selection : searchDataService.selection;
        var selectedTech = chkTechnique.join('-');

        var chkSpectral = searchDataService.showBackupData == false ? $scope.selectionSpectral : searchDataService.selectionSpectral;
        var selectedSpectral = chkSpectral.join('-');

        var keywordSearch = angular.element("#advKeywords").val().replace('"', '');

        var SearchString = "KeyWord:" + keywordSearch + "|ChemicalName:" + angular.element("#chemicalName").val() + "|Element:" + angular.element("#element").val() + "|HostMaterial:" + angular.element("#hostMaterial").val() + "|Transition:" + angular.element("#transition").val() + "|Technique:" + selectedTech.trim() + "|Accession:" + angular.element("#articleName").val() + "|AuthorLastName:" + angular.element("#authorLName").val() + "|SpectralRegion:" + selectedSpectral.trim() + "|StartValue:" + angular.element("#enegryStartVal").val() + "|EndValue:" + angular.element("#enegryEndVal").val() + "|FromYear:" + angular.element("#fromDate").val() + "|Todate:" + angular.element("#toDate").val() + "|Doi:" + angular.element("#doi").val() + "";
        var UvVisSearchString = "KeyWord:" + keywordSearch + "|ChemicalName:" + angular.element("#chemicalName").val() + "|CasRegistryNumber:" + angular.element("#casRegistryNumber").val() + "|Technique:" + selectedTech.trim() + "|AuthorLastName:" + angular.element("#authorLName").val() + "|PublicationYear:" + angular.element("#pubYear").val() + "|SourceTitle:" + angular.element("#articleName").val();
        SearchString = technique.toLowerCase() == 'uv-vis' ? UvVisSearchString : SearchString;
        plotDataService.addSearchString(SearchString.toString(), spectrumId, $scope.workareaId, true);
        var rowid = parseInt(spectrumId) == 0 ? fileName : objectId;
        var newRow = '<tr id="addedChemicalProp-row' + rowid + '" class="added-row"><td class="chem-details">' + createString + '</td><td><button class="fa fa-trash-o remove-dataset pull-right fa-1-5x fa-btn" data-Id="' + rowid + '" data-tech="' + technique + '" title="Remove" ng-click="RemoveDataset(' + rowid + ')"></button></td></tr>';
        var compiledHtml = $compile(newRow)($scope);
        angular.element(document.getElementById('addedChemicals')).append(compiledHtml);

        $(".plot-chart").removeClass("disabled");
        $(".plot-chart").prop("disabled", false);
        $(".clear-all-datasets").show();
        $(".no-chemical-msg").hide();
        $(".added-chemicals-title").removeClass("title-border-bottom");
        $("#addedChemicals tbody").find("#addedChemicalProp-row" + rowid).fadeIn(function () {
            $("#addedChemicals tbody").find("#addedChemicalProp-row" + rowid).removeClass("added-row");
        });

        //plotDataService.setTechnique(objectId, technique, true);
    }
    $scope.RemoveDataset = function (spectraObjectID) {
        plotDataService.removeSpectrumIds(spectraObjectID);
        plotDataService.removeFiles(spectraObjectID);
        plotDataService.removeObjectIds(spectraObjectID);
        plotDataService.setTechnique(spectraObjectID, technique, false);
        plotDataService.removeDataSetDisplayString(spectraObjectID);
        plotDataService.removeDataSetDisplayString(spectraObjectID);
        plotDataService.removeSearchString(spectraObjectID);
        plotDataService.removeSearchString(spectraObjectID);
        $('.row'+spectraObjectID).removeClass('added-row');
    };
    $scope.SetWorkSpaceData();

    $scope.SetWorkSpaceFileData();

    $scope.changedField = '';

    $scope.searchResultMsg = "Kindly search for a dataset.";

    $scope.viewMyDataSearchResultMsg = "Kindly search for a dataset.";

    $scope.setTextboxStyle = function () {
        $(".input-feild-textbox").on("focusin", function () {
            $(this).parent().siblings("label").addClass("active");
            $(this).siblings("label").addClass("active");
        }).focusout(function () {
            if (!$(this).val().trim()) {
                $(this).parent().siblings("label").removeClass("active");
                $(this).siblings("label").removeClass("active");
            }
        });
    };

    $scope.setTextboxStyle();

    $scope.search = function (clickedFrom) {
        $rootScope.fromworkspaceurl = false;
        progressBarService.showProgressBar();
        $scope.clickedFromSearchButton = false;

        if ($scope.selectedTechs != undefined && !angular.equals($scope.selectedTechs, $scope.selection)) {
            $scope.ClearSpectrumIds();
            progressBarService.showProgressBar();
        }
        if (clickedFrom == 'SearchButton') {
            searchDataService.showBackupData = false;
            $scope.clickedFromSearchButton = true;

            $scope.currentPage = 1;
            $scope.viewMyDataCurrentPage = 1;
            $scope.viewTeamDataCurrentPage = 1;

            searchDataService.currentPage = 1;
            searchDataService.viewMyDataCurrentPage = 1;
            searchDataService.viewTeamDataCurrentPage = 1;

            $scope.pagingInfo.sortBy = 'doi';
            $scope.pagingInfo.reverse = true

        }

        if ($("#searchUploadChemicals input[type=text]").hasClass("border-red")) {
            $("#searchUploadChemicals input[type=text].border-red").focus();
            progressBarService.hideProgressBar();
            return false;
        }

        if ($rootScope.SelectedWorkArea != undefined && $rootScope.SelectedWorkArea.isUVTechData) {
            $scope.selection = ['UV-VIS'];
            searchDataService.selection = $scope.selection;
        }

        var chkTechnique = searchDataService.showBackupData == false ? $scope.selection : searchDataService.selection;
        var selectedTech = chkTechnique.join();
        //$scope.isUVTechSelected = selectedTech.toLowerCase() == 'uv-vis' ? true : false;

        if (selectedTech.toLowerCase() == 'uv-vis') {
            $scope.isUVTechSelected = true;
            $scope.selectionSpectral = [];
            searchDataService.selectionSpectral = [];
            angular.forEach($scope.techniques, function (value, key) {
                if (value.name.toLowerCase() != "uv-vis") {
                    $scope.techniques[key].selected = false;
                } else {
                    $scope.techniques[key].selected = true;
                }
            });

        } else {
            angular.forEach(chkTechnique, function (value, key) {
                $scope.techniques[findIndexFromArrayList(value)].selected = true;
            });
        }

        var chkSpectral = searchDataService.showBackupData == false ? $scope.selectionSpectral : searchDataService.selectionSpectral;
        var selectedSpectral = chkSpectral.join();

        if ($scope != null && $scope.pagingInfo != null) {
            $scope.pagingInfo.chemicalName = searchDataService.showBackupData == false ? $("#chemicalName").val().trim() : searchDataService.pagingInfo.chemicalName;
            $scope.pagingInfo.hostMaterial = !$scope.isUVTechSelected && searchDataService.showBackupData == false ? $("#hostMaterial").val().trim() : searchDataService.pagingInfo.hostMaterial;
            $scope.pagingInfo.transition = !$scope.isUVTechSelected && searchDataService.showBackupData == false ? $("#transition").val().trim() : searchDataService.pagingInfo.transition.trim();
            $scope.pagingInfo.element = !$scope.isUVTechSelected && searchDataService.showBackupData == false ? $("#element").val().trim() : searchDataService.pagingInfo.element.trim();
            $scope.pagingInfo.authorLName = searchDataService.showBackupData == false ? $("#authorLName").val().trim() : searchDataService.pagingInfo.authorLName;
            $scope.pagingInfo.fromDate = !$scope.isUVTechSelected && searchDataService.showBackupData == false ? $("#fromDate").val().trim() : searchDataService.pagingInfoDate.startVal; //$("#fromDate").val().trim();
            $scope.pagingInfo.toDate = !$scope.isUVTechSelected && searchDataService.showBackupData == false ? $("#toDate").val().trim() : searchDataService.pagingInfoDate.endVal;// $("#toDate").val().trim();
            $scope.pagingInfo.articleName = searchDataService.showBackupData == false ? $("#articleName").val().trim() : searchDataService.pagingInfo.articleName;
            $scope.pagingInfo.startVal = !$scope.isUVTechSelected && searchDataService.showBackupData == false ? $scope.pagingInfoEnegry.startVal : searchDataService.pagingInfoEnegry.startVal; //$("#startVal").val().trim();
            $scope.pagingInfo.endVal = !$scope.isUVTechSelected && searchDataService.showBackupData == false ? $scope.pagingInfoEnegry.endVal : searchDataService.pagingInfoEnegry.endVal; // $("#endVal").val().trim();
            $scope.pagingInfo.spectralRegion = !$scope.isUVTechSelected && selectedSpectral.trim();
            $scope.pagingInfo.keywords = searchDataService.showBackupData == false ? $("#advKeywords").val().trim() : searchDataService.pagingInfo.keywords;
            $scope.pagingInfo.technique = selectedTech.trim();
            $scope.pagingInfo.doi = !$scope.isUVTechSelected && searchDataService.showBackupData == false ? $("#doi").val().trim() : searchDataService.pagingInfo.doi;

            if (!$scope.isUVTechSelected) {
                if ($scope.pagingInfo.fromDate == "") {
                    $scope.pagingInfo.fromDate = "1992"
                }
                if ($scope.pagingInfo.toDate == "") {
                    $scope.pagingInfo.toDate = new Date().getFullYear();
                }

                if ($scope.pagingInfo.startVal != "" || $scope.pagingInfo.endVal != "") {
                    $scope.pagingInfo.rangeApplied = true;
                }

                $scope.pagingInfoDate.startVal = $("#fromDate").val();
                $scope.pagingInfoDate.endVal = $("#toDate").val();
                //}

                if (!$scope.pagingInfoEnegry) {
                    $scope.pagingInfoEnegry = searchDataService.pagingInfoEnegry;
                }
                searchDataService.pagingInfoEnegry = $scope.pagingInfoEnegry;
                if (!$scope.pagingInfoDate) {
                    $scope.pagingInfoDate = searchDataService.pagingInfoDate;
                }
                searchDataService.pagingInfoDate = $scope.pagingInfoDate;

                plotDataService.setStartEndValues($scope.pagingInfo.startVal, $scope.pagingInfo.endVal);
            }
            var pagingInfo = angular.copy($scope.pagingInfo);
            searchDataService.pagingInfo = $scope.pagingInfo;
        }

        if (clickedFrom == 'SearchButton') {
            $scope.pagingInfoBackup = angular.copy($scope.pagingInfo);
        } else {
            $scope.pagingInfoBackup = searchDataService.pagingInfo;
        }

        if ($scope.currentTab == 1 || $scope.clickedFromSearchButton) {
            pagingInfo.pageNo = $scope.currentPage;
            pagingInfo.sortBy = $scope.isUVTechSelected && $scope.pagingInfo.sortBy.toLowerCase() == "doi" ? 'chemicalName' : $scope.pagingInfo.sortBy;
            pagingInfo.reverse = $scope.pagingInfo.reverse;
            $scope.pagingInfo.pageNo = pagingInfo.pageNo;

        } else if ($scope.currentTab == 2) {
            pagingInfo.pageNo = $scope.viewMyDataCurrentPage;
            pagingInfo.sortBy = $scope.viewMyDataPagingInfo.sortBy;
            pagingInfo.reverse = $scope.viewMyDataPagingInfo.reverse;
            $scope.viewMyDataPagingInfo.pageNo = pagingInfo.pageNo;

        } else if ($scope.currentTab == 3) {
            pagingInfo.pageNo = $scope.viewTeamDataCurrentPage;
            pagingInfo.sortBy = $scope.viewTeamDataPagingInfo.sortBy;
            pagingInfo.reverse = $scope.viewTeamDataPagingInfo.reverse;
            $scope.viewTeamDataPagingInfo.pageNo = pagingInfo.pageNo;
        }

        //pagingInfo.pageNo = $scope.currentTab == 1 ? $scope.currentPage : $scope.viewMyDataCurrentPage;
        //pagingInfo.sortBy = $scope.currentTab == 1 || $scope.clickedFromSearchButton ? $scope.pagingInfo.sortBy : $scope.viewMyDataPagingInfo.sortBy;
        //pagingInfo.reverse = $scope.currentTab == 1 ? $scope.pagingInfo.reverse : $scope.viewMyDataPagingInfo.reverse;
        //if ($scope.currentTab == 1) {
        //    $scope.pagingInfo.pageNo = pagingInfo.pageNo;
        //} else {
        //    $scope.viewMyDataPagingInfo.pageNo = pagingInfo.pageNo;
        //}

        searchservice.search($scope, pagingInfo);
        $scope.setTextboxStyle();
    };

    $scope.setPage = function (pageNo) {
        if ($scope.currentTab == 1) {
            if ($('#searchResultsTable > tbody > tr').length > 0) {
                $scope.currentPage = pageNo;
                searchDataService.currentPage = pageNo;
            }
        } else if ($scope.currentTab == 2) {
            if ($('#viewMyDataSearchResultsTable > tbody > tr').length > 0) {
                $scope.viewMyDataCurrentPage = pageNo;
                searchDataService.viewMyDataCurrentPage = pageNo;
            }
        } else if ($scope.currentTab == 3) {
            if ($('#viewTeamDataSearchResultsTable > tbody > tr').length > 0) {
                $scope.viewTeamDataCurrentPage = pageNo;
                searchDataService.viewTeamDataCurrentPage = pageNo;
            }
        }

        $scope.currentPage = searchDataService.currentPage;
        $scope.viewMyDataCurrentPage = searchDataService.viewMyDataCurrentPage;
        $scope.viewTeamDataCurrentPage = searchDataService.viewTeamDataCurrentPage;

        $scope.search();
    };

    $scope.SearchCriteriaChanged = function () {

        if ($scope.pagingInfoBackup.chemicalName != $("#chemicalName").val().trim()) {
            return true;
        }
        if ($("#hostMaterial").val() != undefined && $scope.pagingInfoBackup.hostMaterial != $("#hostMaterial").val().trim()) {
            return true;
        }
        if ($("#element").val() != undefined && $scope.pagingInfoBackup.element != $("#element").val().trim()) {
            return true;
        }
        if ($("#transition").val() != undefined && $scope.pagingInfoBackup.transition != $("#transition").val().trim()) {
            return true;
        }
        if ($scope.pagingInfoBackup.keywords != $("#advKeywords").val().trim()) {
            return true;
        }
        if ($("#doi").val() != undefined && $scope.pagingInfoBackup.doi != $("#doi").val().trim()) {
            return true;
        }
        if ($("#pubYear").val() != undefined && $scope.pagingInfoBackup.pubYear != $("#pubYear").val().trim()) {
            return true;
        }
        if ($("#casRegistryNumber").val() != undefined && $scope.pagingInfoBackup.casRegistryNumber != $("#casRegistryNumber").val().trim()) {
            return true;
        }
        if ($scope.pagingInfoBackup.articleName != $("#articleName").val().trim()) {
            return true;
        }
        if ($scope.pagingInfoBackup.authorLName != $("#authorLName").val().trim()) {
            return true;
        }
        var chkSpectral = $scope.selectionSpectral
        var selectedSpectral = chkSpectral.join();
        var chkTechnique = $scope.selection;
        var selectedTech = chkTechnique.join();
        if ($scope.pagingInfoBackup.technique != selectedTech.trim()) {
            return true;
        }

        return false;
    };

    // Instantiate the Bloodhound suggestion engine
    var autoCompleteData = new Bloodhound({
        datumTokenizer: function (datum) {
            return Bloodhound.tokenizers.whitespace(datum.value);
        },
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: $scope.serviceBase + "searchSuggession?",
            replace: function (url, uriEncodedQuery) {
                if ($scope.CallAutoSuggession($scope.changedField, $("#" + $scope.changedField).val()) == true) {
                    var changeField = $scope.changedField == "advKeywords" ? "Keywords" : $scope.changedField;
                    changeField = changeField == "sourceTitle" ? "articleName" : changeField;
                    var res = (url + changeField + '=' + encodeURIComponent(uriEncodedQuery) + '&technique=' + $scope.selection.join())// + '&searchBy=' + $scope.postedBy)
                    return res
                }
                else {
                    return false;
                }
            },
            clearRemoteCache: function clearRemoteCache() {
                this.transport && Transport.resetCache();
            },
            filter: function (autoCompleteData) {
                return $.map(autoCompleteData, function (movie) {
                    return {
                        value: movie,
                    };
                });
            }
        },
        limit: 100
    });

    // Initialize the Bloodhound suggestion engine
    autoCompleteData.initialize();

    // Instantiate the Typeahead UI
    $scope.fieldChanged = function (fieldName, e) {
        if (e.keyCode == '13') {
            $("#" + fieldName).typeahead('close');
        }
        if ($scope.CallAutoSuggession(e.target.id, e.target.value) == true) {
            if ($scope.changedField != fieldName && e.keyCode != "9" && e.keyCode != "13") {
                $scope.changedField = fieldName;
                $("#" + $scope.changedField).typeahead('destroy');
                $("#" + $scope.changedField).typeahead(null, {
                    displayKey: 'value',
                    minLength: 2,
                    source: autoCompleteData.ttAdapter(),
                    limit: 100,
                    dupChecker: true
                });
                //$("#" + $scope.changedField).focus();
                setTimeout(function () {
                    $("#" + $scope.changedField).focus();
                    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
                    if (isIE11) {
                        $("#" + $scope.changedField).val($("#" + $scope.changedField).val())
                    }
                }, 100);
            }
        }
    }

    $scope.redirectToPlotGraph = function (path) {
        $timeout(function () {
            progressBarService.showProgressBar();
            $timeout(function () {
                $location.path(path);
            }, 300);
        }, 0);
    }


    $scope.ShowUnsavedWorkspaceModal = function (obj, spectraObjectID, spectrumId, technique, chemicalName, hostMaterial, spectralRegion, publicationYear, doi, fileName, isCurated, contentType, casRegistryNum, pubYear, index, resultType) {
        if ($rootScope.selectedWorkspaceName == 'Choose Workspace' || getCookie("isShowUnsavedWorkspaceModal", $cookies) || obj.currentTarget.classList.contains("remove-chemical")) {
            publicationYear = technique.toLowerCase() == 'uv-vis' ? pubYear : publicationYear;
            $scope.SetDataSet(obj, spectraObjectID, spectrumId, technique, chemicalName, hostMaterial, spectralRegion, publicationYear, doi, fileName, isCurated, contentType, casRegistryNum, index);
            $('#enable-add-chemical').text('1');
        } else {
            $scope.dataSetIndex = index;
            $scope.resultType = resultType;
            $scope.eventObj = obj;
            $scope.isShowUnsavedWorkspaceModal = false;
            if ($('.fa-add-chemical').length == 1) {
                $('.fa-add-chemical')[0].classList.remove('fa-add-chemical');
            }
            if (!$scope.isShowUnsavedWorkspaceModal) {
                $('#enable-add-chemical').text('0');
            }
            $scope.eventObj.currentTarget.classList.add('fa-add-chemical');
            $('#unsaved-wrokspace').modal('show');
        }
    }

    $scope.ContinueAddingDataSet = function () {
        if ($scope.isShowUnsavedWorkspaceModal) {
            setCookie("isShowUnsavedWorkspaceModal", $scope.isShowUnsavedWorkspaceModal, $cookies);
            $('#enable-add-chemical').text('1');
        }
        if ($scope.resultType != undefined) {
            $scope.SetDataSet($scope.eventObj, $scope.searchResults[$scope.dataSetIndex].spectraObjectID, $scope.searchResults[$scope.dataSetIndex].spectrumID, $scope.searchResults[$scope.dataSetIndex].technique, $scope.searchResults[$scope.dataSetIndex].chemicalName, $scope.searchResults[$scope.dataSetIndex].hostMaterial, $scope.searchResults[$scope.dataSetIndex].spectralRegion, $scope.searchResults[$scope.dataSetIndex].publicationYear, $scope.searchResults[$scope.dataSetIndex].doi, $scope.searchResults[$scope.dataSetIndex].fileName, $scope.searchResults[$scope.dataSetIndex].isCurated, $scope.searchResults[$scope.dataSetIndex].contentType, $scope.dataSetIndex)
        } else {
            $scope.SetDataSet($scope.eventObj, $scope.viewMyDataSearchResults[$scope.dataSetIndex].spectraObjectID, $scope.viewMyDataSearchResults[$scope.dataSetIndex].spectrumID, $scope.viewMyDataSearchResults[$scope.dataSetIndex].technique, $scope.viewMyDataSearchResults[$scope.dataSetIndex].chemicalName, $scope.viewMyDataSearchResults[$scope.dataSetIndex].hostMaterial, $scope.viewMyDataSearchResults[$scope.dataSetIndex].spectralRegion, $scope.viewMyDataSearchResults[$scope.dataSetIndex].publicationYear, $scope.viewMyDataSearchResults[$scope.dataSetIndex].doi, $scope.viewMyDataSearchResults[$scope.dataSetIndex].fileName, $scope.viewMyDataSearchResults[$scope.dataSetIndex].isCurated, $scope.dataSetIndex)
        }
    }

    $scope.SetDataSet = function (obj, spectraObjectID, spectrumId, technique, chemicalName, hostMaterial, spectralRegion, publicationYear, doi, fileName, isCurated, contentType, casRegistryNum, index) {
        $('#unsaved-wrokspace').modal('hide');
        contentType = contentType == null ? '' : contentType.toString();
        if (obj.target.className.search("remove-chemical") < 0) {
            spectrumId = spectrumId == 0 && contentType.toLowerCase() == 'kratos' ? spectraObjectID : spectrumId;  // if spectrum id is null for kratos
            if (spectrumId != 0) {
                plotDataService.addSpectrumId(spectraObjectID);
            }
            if (contentType.toLowerCase() != 'kratos' && fileName != null && fileName != undefined && fileName != "") {// if spectrum id is null for kratos
                plotDataService.addFileList(spectraObjectID);
            }

            //if (spectraObjectID != 0) {
            //    plotDataService.addObjectId(spectraObjectID);
            //}

            var createString;
            var selectedField = [];

            selectedField.push(doi);

            plotDataService.addChemicalname(chemicalName);

            if (technique != null && technique != "") {
                selectedField.push(technique);
            }

            if (chemicalName != null && chemicalName != "") {
                selectedField.push(chemicalName);
            }

            //if (hostMaterial != null && hostMaterial != "") {
            //    selectedField.push(hostMaterial);
            //}

            if (spectralRegion != null && spectralRegion != "") {
                selectedField.push(spectralRegion);
            }

            if (publicationYear != null && publicationYear != "") {
                selectedField.push(publicationYear.split("-")[0]);
            }

            createString = selectedField.join(" - ");

            var chkTechnique = $scope.selection;
            var selectedTech = chkTechnique.join('-');

            var chkSpectral = technique.toLowerCase() == 'uv-vis' ? [] : $scope.selectionSpectral;
            var selectedSpectral = chkSpectral.join('-');

            //var rowid = parseInt(spectrumId) == 0 ? fileName.split('.')[0].replace(/ /g, '') : spectrumId;

            var newRow = '<tr id="addedChemicalProp-row' + spectraObjectID + '" class="added-row" style="display:none;"><td class="chem-details">' + createString + '</td><td><button class="fa fa-trash-o remove-dataset pull-right fa-1-5x fa-btn" data-Id="' + spectraObjectID + '" data-tech="' + technique + '" title="Remove" ng-click="RemoveDataset(' + spectraObjectID + ')"></button></td></tr>';
            var compiledHtml = $compile(newRow)($scope);
            angular.element(document.getElementById('addedChemicals')).append(compiledHtml);

            $("#addedChemicals tbody").find("#addedChemicalProp-row" + spectraObjectID).fadeIn(function () {
                $("#addedChemicals tbody").find("#addedChemicalProp-row" + spectraObjectID).removeClass("added-row");
            });
            var keywordSearch = angular.element("#advKeywords").val().replace('"', '')
            var SearchString = "KeyWord:" + keywordSearch + "|ChemicalName:" + angular.element("#chemicalName").val() + "|Element:" + angular.element("#element").val() + "|HostMaterial:" + angular.element("#hostMaterial").val() + "|Transition:" + angular.element("#transition").val() + "|Technique:" + selectedTech.trim() + "|Accession:" + angular.element("#articleName").val() + "|AuthorLastName:" + angular.element("#authorLName").val() + "|SpectralRegion:" + selectedSpectral.trim() + "|StartValue:" + angular.element("#enegryStartVal").val() + "|EndValue:" + angular.element("#enegryEndVal").val() + "|FromYear:" + angular.element("#fromDate").val() + "|Todate:" + angular.element("#toDate").val() + "|Doi:" + angular.element("#doi").val() + "";
            var UvVisSearchString = "KeyWord:" + keywordSearch + "|ChemicalName:" + angular.element("#chemicalName").val() + "|CasRegistryNumber:" + angular.element("#casRegistryNumber").val() + "|Technique:" + selectedTech.trim() + "|AuthorLastName:" + angular.element("#authorLName").val() + "|PublicationYear:" + angular.element("#pubYear").val() + "|SourceTitle:" + angular.element("#articleName").val();
            SearchString = technique.toLowerCase() == 'uv-vis' ? UvVisSearchString : SearchString;

            plotDataService.addSearchString(SearchString.toString(), spectrumId > 0 ? spectraObjectID : 0, spectrumId, $scope.workareaId, fileName != "" && contentType.toLowerCase() != 'kratos' ? spectraObjectID : "", true, casRegistryNum, publicationYear); // // if spectrum id is null for kratos
            plotDataService.addSetdata($scope.workareaId, spectrumId > 0 ? spectraObjectID : 0, spectrumId, technique, chemicalName, hostMaterial, spectralRegion, publicationYear, doi, fileName != "" && contentType.toLowerCase() != 'kratos' ? spectraObjectID : "", isCurated, true, index); //// if spectrum id is null for kratos
            plotDataService.setTechnique(spectraObjectID, technique, true);
        }
        else {
            plotDataService.removeSpectrumIds(spectraObjectID);
            plotDataService.removeFiles(spectraObjectID);
            plotDataService.removeObjectIds(spectraObjectID);
            plotDataService.setTechnique(spectraObjectID, technique, false);
            plotDataService.removeDataSetDisplayString(spectraObjectID);
            plotDataService.removeDataSetDisplayString(fileName);
            plotDataService.removeDataSetDisplayString(spectraObjectID);
            plotDataService.removeSearchString(spectrumId);
            plotDataService.removeSearchString(fileName);
            plotDataService.removeSearchString(spectraObjectID);
        }
    }

    $scope.CallAutoSuggession = function (fieldId, fieldValue) {
        var returnVal = false;
        switch (fieldId) {
            case 'Keywords':
            case 'advKeywords':
            case 'chemicalName':
            case 'hostMaterial':
            case 'transition':
            case 'authorLName':
            case 'articleName':
            case 'hostMaterial':
            case 'casRegistryNumber':
            case 'pubYear':
            case 'sourceTitle':
                if (fieldValue.length >= 2) {
                    returnVal = true;
                }
                break;
            case 'element':
                if (fieldValue.length >= 1) {
                    returnVal = true;
                }
                break;
            case 'doi':
                if (fieldValue.length >= 8) {
                    returnVal = true;
                }
                break;
            default:
                break;
        }

        return returnVal;
    }

    //TODO-START : Make it a server side API call and fetch date from there
    var xmlHttp;
    function srvTime() {
        try {
            //FF, Opera, Safari, Chrome
            xmlHttp = new XMLHttpRequest();
        }
        catch (err1) {
            //IE
            try {
                xmlHttp = new ActiveXObject('Msxml2.XMLHTTP');
            }
            catch (err2) {
                try {
                    xmlHttp = new ActiveXObject('Microsoft.XMLHTTP');
                }
                catch (eerr3) {
                    //AJAX not supported, use CPU time.
                    alert("AJAX not supported");
                }
            }
        }
        xmlHttp.open('HEAD', window.location.href.toString(), false);
        xmlHttp.setRequestHeader("Content-Type", "text/html");
        xmlHttp.send('');
        return xmlHttp.getResponseHeader("Date");
    }
    //TODO-END : Make it a server side API call and fetch date from there

    $scope.GetDataSetStatus = function (XYDataCount, dataSetId) {
        var retVal = 0;
        if (XYDataCount > 0) {
            retVal = 1;
            if (plotDataService.isSpectrumIdExist(dataSetId) >= 0) {
                retVal = 2;
            }
        }
        return retVal;
    };

    $scope.GetDataSetStatusForObjectId = function (XYDataCount, dataSetId) {
        var retVal = 0;
        if (XYDataCount > 0) {
            retVal = 1;
            if (plotDataService.isObjectIdExist(dataSetId) >= 0) {
                retVal = 2;
            }
        }
        return retVal;
    };

    $scope.GetDataSetStatusForFile = function (fileName) {
        var retVal = 0;
        if (fileName.length > 0) {
            retVal = 1;
            //var datalist = plotDataService.getSetdata();
            //$.each(datalist, function (index, key) {
            //    if (key.FileName == fileName) {
            //        retVal = 2;
            //    }
            //});
            if (plotDataService.isFileExist(parseInt(fileName)) >= 0) {
                retVal = 2;
            }

        }

        return retVal;
    };

    $scope.RemoveSelectedDataSet = function (objectId, technique) {

        //if (fileName != null && fileName != undefined && fileName != "") {
        //    plotDataService.removeFiles(fileName);
        //    plotDataService.removeDataSetDisplayString(fileName);
        //    plotDataService.removeSearchString(fileName);
        //} else {
        //    plotDataService.setTechnique(spectrumId, technique, false);
        //    plotDataService.removeSpectrumIds(spectrumId);
        //    plotDataService.removeDataSetDisplayString(spectrumId);
        //    plotDataService.removeSearchString(spectrumId);
        //}
        plotDataService.removeFiles(objectId);
        plotDataService.removeSpectrumIds(objectId);
        plotDataService.setTechnique(objectId, technique, false);
        plotDataService.removeObjectIds(objectId);
        plotDataService.removeDataSetDisplayString(objectId);
        plotDataService.removeSearchString(objectId);

    }

    $scope.sort = function (sortBy) {

        if ($("#searchUploadChemicals input[type=text]").hasClass("border-red") || $scope.SearchCriteriaChanged()) {
            progressBarService.hideProgressBar();
            return false;
        }
        if ($scope.currentTab == 1) {
            if (sortBy === $scope.pagingInfo.sortBy) {
                $scope.pagingInfo.reverse = !$scope.pagingInfo.reverse;
                searchDataService.pagingInfo.reverse = $scope.pagingInfo.reverse;
            } else {
                $scope.pagingInfo.sortBy = sortBy;
                $scope.pagingInfo.reverse = false;

                searchDataService.pagingInfo.sortBy = sortBy;
                searchDataService.pagingInfo.reverse = false;
            }

            $scope.pagingInfo.page = 1;
            $scope.currentPage = 1;

            searchDataService.pagingInfo.page = 1;
            searchDataService.currentPage = 1;
        } else if ($scope.currentTab == 2) {
            if (sortBy === $scope.viewMyDataPagingInfo.sortBy) {
                //$scope.pagingInfo.reverse = !$scope.viewMyDataPagingInfo.reverse;
                $scope.viewMyDataPagingInfo.reverse = !$scope.viewMyDataPagingInfo.reverse;
                searchDataService.viewMyDataPagingInfo.reverse = $scope.viewMyDataPagingInfo.reverse;
            } else {
                //$scope.pagingInfo.sortBy = sortBy;
                //$scope.pagingInfo.reverse = false;

                $scope.viewMyDataPagingInfo.sortBy = sortBy;
                $scope.viewMyDataPagingInfo.reverse = false;

                searchDataService.viewMyDataPagingInfo.sortBy = sortBy;
                searchDataService.viewMyDataPagingInfo.reverse = false;
            }
            $scope.viewMyDataPagingInfo.page = 1;
            $scope.viewMyDataCurrentPage = 1;

            searchDataService.viewMyDataPagingInfo.page = 1;
            searchDataService.viewMyDataCurrentPage = 1;
        } else if ($scope.currentTab == 3) {
            if (sortBy === $scope.viewTeamDataPagingInfo.sortBy) {
                //$scope.pagingInfo.reverse = !$scope.viewMyDataPagingInfo.reverse;
                $scope.viewTeamDataPagingInfo.reverse = !$scope.viewTeamDataPagingInfo.reverse;
                searchDataService.viewTeamDataPagingInfo.reverse = $scope.viewTeamDataPagingInfo.reverse;
            } else {
                //$scope.pagingInfo.sortBy = sortBy;
                //$scope.pagingInfo.reverse = false;

                $scope.viewTeamDataPagingInfo.sortBy = sortBy;
                $scope.viewTeamDataPagingInfo.reverse = false;

                searchDataService.viewTeamDataPagingInfo.sortBy = sortBy;
                searchDataService.viewTeamDataPagingInfo.reverse = false;
            }
            $scope.viewTeamDataPagingInfo.page = 1;
            $scope.viewTeamDataCurrentPage = 1;

            searchDataService.viewTeamDataPagingInfo.page = 1;
            searchDataService.viewTeamDataCurrentPage = 1;
        }
        $scope.search();
    };


    // toggle selection for a given techniques by name
    $scope.toggleSelection = function toggleSelection(techniqueName, index) {
        var idx = $scope.selection.indexOf(techniqueName);
        $scope.techniques[index].selected = !$scope.techniques[index].selected;
        if (!$scope.techniques[index].selected) {
            if (techniqueName.toLowerCase() == "uv-vis") {
                $scope.isUVTechSelected = false;
            }
            if (idx > -1) {
                $scope.selection.splice(idx, 1);
            }
        }
        else {
            // $scope.techniques[index].selected = true;
            var tempIdx;
            if (techniqueName.toLowerCase() == "uv-vis") {
                $scope.isUVTechSelected = true;
                angular.forEach($scope.techniques, function (value, key) {
                    if (value.name.toLowerCase() != "uv-vis") {
                        $scope.techniques[key].selected = false;
                    }
                });
                $scope.selection = [];
                $scope.selectionSpectral = [];
            } else {
                $scope.isUVTechSelected = false;
            }
            if (techniqueName.toLowerCase() == "xps" || techniqueName.toLowerCase() == "ups") {
                $scope.techniques[findIndexFromArrayList('AES')].selected = false;
                $scope.techniques[findIndexFromArrayList('UV-VIS')].selected = false;
                RemoveTech('AES');
                RemoveTech('UV-VIS');
            }

            if (techniqueName.toLowerCase() == "aes") {
                $scope.techniques[findIndexFromArrayList('UV-VIS')].selected = false;
                $scope.techniques[findIndexFromArrayList('XPS')].selected = false;
                $scope.techniques[findIndexFromArrayList('UPS')].selected = false;
                RemoveTech('UV-VIS');
                RemoveTech('XPS');
                RemoveTech('UPS');
            }

            if (techniqueName.toLowerCase() == "unspecified") {
                $scope.techniques[findIndexFromArrayList('UV-VIS')].selected = false;
                RemoveTech('UV-VIS');
            }

            $scope.selection.push(techniqueName);
        }

        searchDataService.selection = $scope.selection;
    };

    function RemoveTech(name) {
        tempIdx = $scope.selection.indexOf(name);
        if (tempIdx > -1) {
            $scope.selection.splice(tempIdx, 1);
        }
    }

    var lIndex = -1;
    function findIndexFromArrayList(value) {
        lIndex = -1;
        $scope.techniques.some(function (obj, i) {
            if (obj.name === value) {
                lIndex = i;
                return true;
            }
        });
        return lIndex;
    }

    $scope.searchResults = searchDataService.searchResultsBackup;
    $scope.viewMyDataSearchResults = searchDataService.viewMyDataSearchResultsBackup;
    $scope.viewTeamDataSearchResults = searchDataService.viewTeamDataSearchResultsBackup;

    $scope.autoComplete = [];

    if ((!$scope.searchResults || $scope.searchResults.length <= 0) && (!$scope.viewMyDataSearchResults || $scope.viewMyDataSearchResults.length <= 0) && (!$scope.viewTeamDataSearchResults || $scope.viewTeamDataSearchResults.length <= 0)) {

        $scope.totalNumberRecords = 1 / 0;
        $scope.viewMyDataTotalNumberRecords = 1 / 0;
        $scope.viewTeamDataTotalNumberRecords = 1 / 0;

        $scope.currentPage = 1;
        $scope.viewMyDataCurrentPage = 1;
        $scope.viewTeamDataCurrentPage = 1;

        if ($scope.currentPage == undefined) {
            $scope.currentPage = 1;
            $scope.viewMyDataCurrentPage = 1;
            $scope.viewTeamDataCurrentPage = 1;
        }

        searchDataService.currentPage = $scope.currentPage;
        searchDataService.viewMyDataCurrentPage = $scope.viewMyDataCurrentPage;
        searchDataService.viewTeamDataCurrentPage = $scope.viewTeamDataCurrentPage;

        $scope.pagingInfo = {
            pageNo: 1,
            itemsPerPage: 10,
            sortBy: 'doi',
            reverse: true,
            keywords: '',
            chemicalName: '',
            hostMaterial: '',
            transition: '',
            element: '',
            authorLName: '',
            spectralRegion: '',
            startVal: '',
            endVal: '',
            fromDate: '',
            toDate: '',
            articleName: '',
            technique: '',
            doi: '',
            rangeApplied: false,
            currentTab: 1,
            casRegistryNumber: '',
            pubYear: ''
        };

        $scope.viewMyDataPagingInfo = {
            pageNo: 1,
            itemsPerPage: 10,
            sortBy: 'publicationyear',
            reverse: true
        };

        $scope.viewTeamDataPagingInfo = {
            pageNo: 1,
            itemsPerPage: 10,
            sortBy: 'publicationyear',
            reverse: true
        };

        searchDataService.pagingInfo = $scope.pagingInfo;
        searchDataService.viewMyDataPagingInfo = $scope.viewMyDataPagingInfo;
        searchDataService.viewTeamDataPagingInfo = $scope.viewTeamDataPagingInfo;

        if (!searchDataService.showBackupData && plotDataService.getSetdata().length > 0) {
            $scope.currentPage = searchDataService.currentPage;
            $scope.viewMyDataCurrentPage = searchDataService.viewMyDataCurrentPage;
            $scope.viewTeamDataCurrentPage = searchDataService.viewTeamDataCurrentPage;

            $scope.pagingInfo = searchDataService.pagingInfo;
            $scope.viewMyDataPagingInfo = searchDataService.viewMyDataPagingInfo;
            $scope.viewTeamDataPagingInfo = searchDataService.viewTeamDataPagingInfo;
            $scope.search();
        }

    } else {
        if (searchDataService.showBackupData) {
            $scope.currentPage = searchDataService.currentPage;
            $scope.viewMyDataCurrentPage = searchDataService.viewMyDataCurrentPage;
            $scope.viewTeamDataCurrentPage = searchDataService.viewTeamDataCurrentPage;

            $scope.pagingInfo = searchDataService.pagingInfo;
            $scope.viewMyDataPagingInfo = searchDataService.viewMyDataPagingInfo;
            $scope.viewTeamDataPagingInfo = searchDataService.viewTeamDataPagingInfo;
            $scope.search();
        }
    }

    $scope.originForm = angular.copy($scope.pagingInfo);

    // toggle selection for a given Spectral region by name
    $scope.toggleSpectralSelection = function toggleSpectralSelection(spectralName) {
        var idx = $scope.selectionSpectral.indexOf(spectralName);

        // is currently selected
        if (idx > -1) {
            $scope.selectionSpectral.splice(idx, 1);
        }
            // is newly selected
        else {
            $scope.selectionSpectral.push(spectralName);
        }

        searchDataService.selectionSpectral = $scope.selectionSpectral;
    };

    $scope.editfilename = function (id) {
        //var tddata = $('#td-data-' + id).html();
        //var tempArray = tddata.split('-');
        //var tempFileName = tddata.substring(tempArray[0].length + 1);
        //$('#td-data-' + id).html('<input type="text" class="form-control input-feild-textbox" name="" id="edit-text-' + id + '" value="' + tempFileName + '"/>');
        //$("#edit-text-" + id).focus();
        //$('#edit-button-' + id).hide();
        //$('#save-button-' + id).show();

        //$scope.SessionUploadID = $cookies.get('SessionID');
        $scope.uniqueID = id.toString();

        searchservice.getfileNameByUniqueID($scope);
    }

    $scope.savefilename = function (id, fileExt) {
        //var regExp = "^[a-zA-Z0-9 \-]+$";
        var textd = $('#edit-text-' + id).val();
        //var flag = textValidate(textd, regExp);
        //if (flag == true && isNaN(textd) && textd != '') {
        if (isNaN(textd) && textd != '') {
            $('#td-data-' + id).html("Upload" + id + "-" + textd);
            $('#edit-button-' + id).show();
            $('#save-button-' + id).hide();

            searchservice.saveFileName($scope, id, textd + fileExt);
        }
        else {
            alert('Please enter valid file name.');
            $('#edit-text-' + id).focus();
            return false;
        }
    }

    $scope.$on('ngRepeatBroadcast1', function (ngRepeatFinishedEvent) {

        assignHeightToSelectedResults();
        progressBarService.hideProgressBar();
    });

    if (($rootScope.SelectedWorkArea != null && $rootScope.SelectedWorkArea.name != '' && (plotDataService.getSpectrumIds().length > 0 || plotDataService.getFiles().length > 0))) {
        $rootScope.selectedWorkspaceName = $rootScope.SelectedWorkArea.name;
        $rootScope.PlotGraphLinkCSS = '';
        angular.element(document.getElementsByClassName("plotting-area")).parent().removeClass("disabled");
        angular.element(document.getElementsByClassName("plotting-area")).removeClass("disabled").attr("disabled", false);
        $scope.scrollTop = true;
    }
    else {
        $rootScope.PlotGraphLinkCSS = 'disabled';
        angular.element(document.getElementsByClassName("plotting-area")).parent().addClass("disabled");
        angular.element(document.getElementsByClassName("plotting-area")).addClass("disabled").attr("disabled", true);
    }

    $scope.showFigureDetails = function (index) {
        $scope.searchResults[index].showFigureDetails = !$scope.searchResults[index].showFigureDetails;
        if ($scope.searchResults[index].showFigureDetails == true) {
            $(".figure-details-tr-" + index).fadeIn('slow');
            $(".figure-details-tr-" + index).removeClass('ng-hide');
        } else {
            $(".figure-details-tr-" + index).fadeOut('slow');
            $(".figure-details-tr-" + index).addClass('ng-hide');
        }
    }

    $scope.toggleCollapsableRows = function ($event) {
        var currentTarget = $event.currentTarget;
        if ($(currentTarget)[0].checked == true) {
            searchDataService.collapsableRowsSwitchOn = true;
            angular.forEach($scope.searchResults, function (value, key) {
                if (value.figuresDetails.length > 0) {
                    $scope.searchResults[key].showFigureDetails = true;
                }
            });
        } else {
            searchDataService.collapsableRowsSwitchOn = false;
            angular.forEach($scope.searchResults, function (value, key) {
                if (value.figuresDetails.length > 0) {
                    $scope.searchResults[key].showFigureDetails = false;
                }
            });
        }
        $scope.collapsableRowsSwitchOn = searchDataService.collapsableRowsSwitchOn;

        $scope.fadeInFadeOutDetails();
    }

    $scope.fadeInFadeOutDetails = function () {
        if ($scope.collapsableRowsSwitchOn == true) {
            $(".collapsable-table-tr").fadeIn('slow');
            $(".switch-text").text('Hide');
        } else {
            $(".collapsable-table-tr").fadeOut('slow');
            $(".switch-text").text('Show');
        }

        angular.forEach($('.collapsable-table-tr'), function (value, key) {
            var trLength = $(value).find('table.collpasable-table > tbody > tr').length;
            if (trLength > 0) {
                $(value).removeClass('ng-hide');
            }
        });
    }

    $scope.$on('$viewContentLoaded', function () {

        $timeout(function () {

            $(".input-feild-textbox").filter(function () {
                if (!$(this).val()) {
                    $(this).siblings("label").removeClass("active");
                } else {
                    $(this).siblings("label").addClass("active");
                }
            });
        }, 0.2);

    });

    //upload Data

    $('#referencedArticle').keyup(function () {
        var _this = $(this);
        storeUploadService.validateReferenceArticle(_this, $scope);
    })

    getTeamInfo();

    $scope.openUploadModel = function () {
        $scope.clear();
        $scope.isEditData = false;
        $scope.showSavebtn = true;
        $scope.isDisableStep1 = false;
        $scope.isDisableStep2 = true;
        $scope.isDisableStep3 = true;
        $scope.validDOI = true;
        $('#fileStatus').text('No file selected.');
        var name = getLocalValue("fullName").split(' ');

        $('#firstName').val(name[0]);
        $('#lastName').val(name[1]);

        $scope.dataManagement.FirstName = name[0];
        $scope.dataManagement.LastName = name[1];

        $('#upload').modal('show');
    }

    function getTeamInfo() {
        $http({
            method: "GET",
            url: $scope.serviceBase + "api/Account/teamInfo",
            headers: {
                'Content-Type': 'application/json'
            }
        }).success(function (data, headers, status) {
            $scope.isTeamPerson = data.isTeamMember;
            $scope.isTeamMember = $scope.isTeamPerson;
        });
    }

    $scope.clear = function () {

        $scope.modalMessage = '';
        $scope.isModalError = false;
        $scope.isModalSuccess = false;

        $scope.FileSelected = false;
        $scope.files = [];

        $scope.SelectedObjectID = 0;

        $("input[type=file]").val('').clone(true);
        //$("form[name=propertiesForm]").trigger('reset');
        $('.border-red').removeClass('border-red');

        $scope.dataManagementValues();

        $scope.dataManagementUpload.$setPristine();
        $scope.dataManagementUpload.$setUntouched();
    }

    $scope.showSpectralRegionRawPopover = function (searchResult, index) {
        if (searchResult.duplicateSpectralRegionRaw.length > 15) {
            $('[data-toggle="popoverTest-' + index + '"]').popover('show');
            var element = document.getElementById("spectralRegionRaw-" + index);
            $(element).siblings(".popover").addClass('spectralRegionRaw-popup-border');
            $(element).siblings(".popover").children('.arrow').addClass('spectralRegionRaw-popup-arrow');
        }
    }

    $scope.hideSpectralRegionRawPopover = function (searchResult, index) {
        if (searchResult.duplicateSpectralRegionRaw.length > 15) {
            $('[data-toggle="popoverTest-' + index + '"]').popover('hide');
        }
    }

    $scope.onFileShareSelected = function (value) {
        storeUploadService.onFileShareSelected(value);
    };

    $scope.uploadFile = function () {

        progressBarService.showProgressBar();
        var data = new FormData();
        data.append("file", $scope.files[0]);
        data.append("eSpectraSpecimenHostMaterial", $scope.dataManagement.HostMaterial);
        data.append("eSpectraSpecimenChemicalName", $scope.dataManagement.ChemicalName);
        data.append("ReferencedArticle", $scope.dataManagement.ReferencedArticle);
        data.append("eSpectraObjectTechnique", $scope.dataManagement.Techinque);
        data.append("eSpectraObjectDesc", $scope.dataManagement.Description);
        data.append("FirstName", $scope.dataManagement.FirstName);
        data.append("LastName", $scope.dataManagement.LastName);
        //data.append("eSpectraSubmitPersonID", $cookies.get("UserId"));
        data.append("eSpectraObjectDOI", $scope.dataManagement.eSpectraObjectDOI);
        data.append("eSpectraObjectCalibration", $scope.dataManagement.eSpectraObjectCalibration);
        data.append("eSpectraObjectShareType", $scope.dataManagement.FileShare);
        data.append("eSpectraCasRegistryNum", $scope.dataManagement.CasRegistryNumber);

        $scope.isDisableStep2 = true;
        $scope.isDisableStep3 = true;
        $scope.isDisableUpload = true;

        dataManagementService.uploadFile(data).then(function (response) {

            if (response != null && response.data.message != undefined) {
                $scope.modalMessage = response.data.message;
                $scope.isModalError = true;
                $scope.isModalSuccess = false;
                $scope.isDisableStep2 = false;
                $scope.isDisableStep3 = false;
                $scope.isDisableUpload = false;
                progressBarService.hideProgressBar();
                //$timeout(hideMessage, 10000);
            }
            else {
                //var data = JSON.parse(response.data);
                $('#upload').modal('toggle');
                $('.border-red').removeClass('border-red');
                $scope.isDisableStep2 = false;
                $scope.isDisableStep3 = false;
                $scope.isDisableUpload = false;
                var data = response.data.status;
                if (data) {
                    $scope.isError = false;
                    $scope.isSuccess = true;
                    $scope.message = GetMessage.dataUploadedSuccessfully;
                    if ($scope.dataManagement.Techinque.toLowerCase() == "uv-vis") {
                        $scope.selection = ['UV-VIS'];
                        searchDataService.selection = $scope.selection;
                        $scope.selectionSpectral = [];
                        searchDataService.selectionSpectral = [];

                        $scope.techniques[findIndexFromArrayList('UV-VIS')].selected = true;
                        $scope.techniques[findIndexFromArrayList('XPS')].selected = false;
                        $scope.techniques[findIndexFromArrayList('UPS')].selected = false;
                        $scope.techniques[findIndexFromArrayList('AES')].selected = false;
                        $scope.techniques[findIndexFromArrayList('Unspecified')].selected = false;

                        $scope.isUVTechSelected = true;
                    }
                    $scope.search();

                    var dataList = [];
                    var dataArray = {
                        eSpectraObjectID: response.data.dataManagementFile.eSpectraObjectID,
                        eSpectraObjectDataSetName: response.data.dataManagementFile.eSpectraObjectDataSetName
                    }
                    dataList.push(dataArray);

                    searchservice.GetObjectData($scope, dataList);
                }
                else {
                    $scope.message = GetMessage.UploadFileIntoElasticSearchFailed;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                progressBarService.hideProgressBar();
            }
        });
    };

    $scope.EditData = function (objectId) {
        $scope.clear();
        $scope.isEditData = true;
        $scope.showSavebtn = false;
        $scope.isDisableStep1 = false;
        $scope.isDisableStep2 = false;
        $scope.isDisableStep3 = false;
        $scope.validDOI = true;
        dataManagementService.getObjectByObjectID(objectId).then(function (response) {
            if (response != null && response.data.message != undefined) {
                $scope.modalMessage = response.data.message;
                $scope.isModalError = true;
                $scope.isModalSuccess = false;
                //$timeout(hideMessage, 10000);
                $('#upload').modal('show');
            }
            else {
                $scope.eSpectraObjectID = response.data.eSpectraObjectID;
                $scope.eSpectraObjectDataSetName = response.data.eSpectraObjectDataSetName;
                $scope.dataManagement.HostMaterial = response.data.eSpectraSpecimenHostMaterial;
                $scope.dataManagement.ChemicalName = response.data.eSpectraSpecimenChemicalName;
                $scope.dataManagement.ReferencedArticle = response.data.eSpectraObjectDOI;
                $scope.dataManagement.Techinque = response.data.eSpectraObjectTechnique;
                $scope.dataManagement.Description = response.data.eSpectraObjectComment;
                $scope.dataManagement.FirstName = response.data.firstName;
                $scope.dataManagement.LastName = response.data.lastName;
                $scope.dataManagement.eSpectraObjectCalibration = response.data.eSpectraObjectCalibration;
                $scope.dataManagement.FileShare = response.data.eSpectraObjectShareType.toLowerCase();
                $scope.dataManagement.isPublic = response.data.eSpectraObjectShareType.toLowerCase() == "public" ? 1 : 0;
                $scope.dataManagement.CasRegistryNumber = response.data.eSpectraCasRegistryNum;
                $scope.isTeamMember = response.data.isTeamMember;
            }
            $('#upload').modal('show');
        });
    }

    $scope.ShowSpectraFiguredetails = function (displayId, spectrunID, fileName) {
        plotgraphservice.getSpectraFiguredetails($scope, displayId);
    }

    $scope.selectedWorkspace = function (mode, workspaceType, savedWorkspace) {
        progressBarService.showProgressBar();
        plotDataService.clearSpectrumIds();
        plotDataService.clearTechnique();
        plotDataService.clearFiles();
        plotDataService.clearDataSetDisplayString();
        plotDataService.clearSearchString();
        $rootScope.SelectedWorkArea = null;
        $scope.WorkAreaid = savedWorkspace.workAreaID;
        $rootScope.selectedWorkspaceName = savedWorkspace.areaName;

        GetSpectrumIDServices.GetWorkSpaceByID($scope, mode, workspaceType);

    }

    $scope.toggleTechDropDown = function () {
        $('#spectralCheckboxes').hide();
        $('#techCheckboxes').toggle();
    }

    $scope.toggleSpectralDropDown = function () {
        $('#techCheckboxes').hide();
        $('#spectralCheckboxes').toggle();
    }

}]);

app.service('searchservice', ['$http', '$cookies', 'searchDataService', 'plotDataService', 'progressBarService', function ($http, $cookies, searchDataService, plotDataService, progressBarService) {

    this.search = function ($scope, pagingInfo) {
        $scope.selectedTechs = [];
        if ($scope.currentTab == 1) {
            $scope.searchResults = null;
            $scope.searchResultMsg = "";
        } else if ($scope.currentTab == 2) {
            $scope.viewMyDataSearchResults = null;
            $scope.viewMyDataSearchResultMsg = "";
        } else if ($scope.currentTab == 3) {
            $scope.viewTeamDataSearchResults = null;
            $scope.viewTeamDataSearchResultMsg = "";
        }
        return $http({
            method: "GET",
            url: $scope.serviceBase + "search",
            params: pagingInfo,
            headers: {
                'Content-Type': 'application/json'
            }
        }).success(function (data, status) {
            if (status == "204") {
                $("#searchResultsContainer").removeClass("in");
                $("#viewMyDataSearchResultsContainer").removeClass("in");
                $("#viewTeamDataSearchResultsContainer").removeClass("in");

                $(".switch").fadeOut();
                $(".switch > input[type='checkbox']").prop('checked', false);
                $(".switch-text").text('Show');

                $scope.searchResultMsg = "No data found.";
                $scope.viewMyDataSearchResultMsg = "No data found.";
                $scope.viewTeamDataSearchResultMsg = "No data found.";

                $(".no-dataset-msg").show();
                $(".no-dataset-msg").addClass("animate");
                setTimeout(function () { $(".no-dataset-msg").removeClass("animate") }, 2000);

                progressBarService.hideProgressBar();
            }
            else {
                angular.forEach($scope.selection, function (value, key) {
                    $scope.selectedTechs.push(value);
                })
                $scope.isUVTechSearchResult = $scope.selection[0].toLowerCase() == 'uv-vis' ? true : false;
                $scope.postedBy = data.loggedInUserId;
                $scope.premiumType = data.premiumType;
                setLocalValue("premiumType", $scope.premiumType);

                if ($scope.pagingInfo.currentTab == 1 || $scope.clickedFromSearchButton == true) {
                    if ($scope.pagingInfo.pageNo == 1) {
                        $scope.totalNumberRecords = data.totalNoOfRecords;
                        searchDataService.totalNumberRecords = data.totalNoOfRecords;

                        $scope.viewMyDataTotalNumberRecords = data.viewMyDataTotalNoOfRecords;
                        searchDataService.viewMyDataTotalNumberRecords = data.viewMyDataTotalNoOfRecords;

                        $scope.viewTeamDataTotalNumberRecords = data.viewTeamDataTotalNoOfRecords;
                        searchDataService.viewTeamDataTotalNumberRecords = data.viewTeamDataTotalNoOfRecords;
                    } else if (!$scope.totalNumberRecords) {
                        $scope.totalNumberRecords = searchDataService.totalNumberRecords;
                    }
                }
                if ($scope.pagingInfo.currentTab == 2) {
                    if ($scope.viewMyDataPagingInfo.pageNo == 1) {
                        $scope.viewMyDataTotalNumberRecords = data.viewMyDataTotalNoOfRecords;
                        searchDataService.viewMyDataTotalNumberRecords = data.viewMyDataTotalNoOfRecords;
                    } else if (!$scope.viewMyDataTotalNumberRecords) {
                        $scope.viewMyDataTotalNumberRecords = searchDataService.viewMyDataTotalNumberRecords;
                    }
                    if (searchDataService.totalNumberRecords) {
                        $scope.totalNumberRecords = searchDataService.totalNumberRecords;
                    }
                }
                if ($scope.pagingInfo.currentTab == 3) {
                    if ($scope.viewTeamDataPagingInfo.pageNo == 1) {
                        $scope.viewTeamDataTotalNumberRecords = data.viewTeamDataTotalNoOfRecords;
                        searchDataService.viewTeamDataTotalNumberRecords = data.viewTeamDataTotalNoOfRecords;
                    } else if (!$scope.viewTeamDataTotalNumberRecords) {
                        $scope.viewTeamDataTotalNumberRecords = searchDataService.viewTeamDataTotalNumberRecords;
                    }
                    if (searchDataService.totalNumberRecords) {
                        $scope.totalNumberRecords = searchDataService.totalNumberRecords;
                    }
                }

                searchDataService.showBackupData = true;
                var count = 0;

                $(".switch").fadeIn();
                searchDataService.collapsableRowsSwitchOn = $scope.isUVTechSearchResult ? false : searchDataService.collapsableRowsSwitchOn;
                $(".switch > input[type='checkbox']").prop('checked', searchDataService.collapsableRowsSwitchOn);
                if (searchDataService.collapsableRowsSwitchOn) {
                    $(".collapsable-table-tr").fadeIn('slow');
                    $(".switch-text").text('Hide');
                } else {
                    $(".collapsable-table-tr").fadeOut('slow');
                    $(".switch-text").text('Show');
                }

                $scope.showFiguresDetailsTableHeader = -1;

                angular.forEach(data.searchResult, function (value, key) {

                    value.resultFlag = $scope.GetDataSetStatus(value.figuresDataCount, value.spectraObjectID);
                    if (value.figuresDetails.length > 0 && $scope.showFiguresDetailsTableHeader == -1) {
                        $scope.showFiguresDetailsTableHeader = count;
                    }
                    if ((value.contentType != null ? value.contentType.toLowerCase() != 'kratos' : true) && value.fileName.length > 0) { // for kratos data with filename
                        value.resultFlag = $scope.GetDataSetStatusForFile(value.spectraObjectID.toString());
                    }
                    value.device = $scope.deviceName;
                    count++;
                });
                if ($scope.pagingInfo.currentTab == 1 || $scope.clickedFromSearchButton == true) {
                    $scope.searchResults = data.searchResult;
                    angular.forEach($scope.searchResults, function (value, key) {
                        $scope.searchResults[key].duplicateSpectralRegionRaw = $scope.searchResults[key].spectralRegionRaw;
                        if (value.spectralRegionRaw != null && value.spectralRegionRaw.length > 15) {
                            if ($scope.searchResults[key].spectralRegionRaw.charAt(14) == ",") {
                                $scope.searchResults[key].spectralRegionRaw = $scope.searchResults[key].spectralRegionRaw.substring(0, 15) + "...";
                            } else {
                                var lastIndexOfComma = $scope.searchResults[key].spectralRegionRaw.substring(0, 15).lastIndexOf(',');
                                $scope.searchResults[key].spectralRegionRaw = $scope.searchResults[key].spectralRegionRaw.substring(0, (lastIndexOfComma + 1)) + "...";
                            }
                        }
                        if (value.figuresDetails.length > 0) {
                            $scope.searchResults[key].showFigureDetails = searchDataService.collapsableRowsSwitchOn == true ? true : false;
                        }
                    });
                    searchDataService.searchResultsBackup = $scope.searchResults;

                    $scope.viewMyDataSearchResults = searchDataService.viewMyDataSearchResultsBackup;
                    $scope.viewMyDataTotalNumberRecords = searchDataService.viewMyDataTotalNumberRecords;

                    $scope.viewTeamDataSearchResults = searchDataService.viewTeamDataSearchResultsBackup;
                    $scope.viewTeamDataTotalNumberRecords = searchDataService.viewTeamDataTotalNumberRecords;

                } else {
                    $scope.searchResults = searchDataService.searchResultsBackup;
                }

                if ($scope.pagingInfo.currentTab == 2 || $scope.clickedFromSearchButton == true) {
                    angular.forEach(data.viewMyDataSearchResult, function (value, key) {

                        value.resultFlag = $scope.GetDataSetStatus(value.figuresDataCount, value.spectraObjectID);
                        if (value.figuresDetails.length > 0 && $scope.showFiguresDetailsTableHeader == -1) {
                            $scope.showFiguresDetailsTableHeader = count;
                        }
                        if (value.fileName.length > 0) {
                            value.resultFlag = $scope.GetDataSetStatusForFile(value.spectraObjectID.toString());
                        }
                        value.device = $scope.deviceName;
                        count++;
                    });
                    $scope.viewMyDataSearchResults = data.viewMyDataSearchResult;
                    searchDataService.viewMyDataSearchResultsBackup = $scope.viewMyDataSearchResults;
                }

                if ($scope.pagingInfo.currentTab == 3 || $scope.clickedFromSearchButton == true) {
                    angular.forEach(data.viewTeamDataSearchResult, function (value, key) {

                        value.resultFlag = $scope.GetDataSetStatus(value.figuresDataCount, value.spectraObjectID);
                        if (value.figuresDetails.length > 0 && $scope.showFiguresDetailsTableHeader == -1) {
                            $scope.showFiguresDetailsTableHeader = count;
                        }
                        if (value.fileName.length > 0) {
                            value.resultFlag = $scope.GetDataSetStatusForFile(value.spectraObjectID.toString());
                        }
                        value.device = $scope.deviceName;
                        count++;
                    });
                    $scope.viewTeamDataSearchResults = data.viewTeamDataSearchResult;
                    searchDataService.viewTeamDataSearchResultsBackup = $scope.viewTeamDataSearchResults;
                }

                $("#searchResultsContainer").addClass("in");
                $("#viewMyDataSearchResultsContainer").addClass("in");
                $("#viewTeamDataSearchResultsContainer").addClass("in");

                //$(".toggle-all-row-element").fadeIn();
                if ($scope.scrollTop == true) {
                    $("html, body").animate({
                        scrollTop: 0
                    }, "500");
                } else {
                    $("html, body").animate({
                        scrollTop: $(".search-results-title").offset().top
                    }, "slow");
                }

                $(".no-dataset-msg").hide();
                progressBarService.hideProgressBar();
            }
        }).error(function (data, status) {
            if (status == "204" || status == "400") {
                $("#searchResultsContainer").removeClass("in");
                $("#viewMyDataSearchResultsContainer").removeClass("in");
                $("#viewTeamDataSearchResultsContainer").removeClass("in");
                //$(".toggle-all-row-element").fadeOut();
                $(".switch").fadeOut();
                $(".switch > input[type='checkbox']").prop('checked', false);
                $(".switch-text").text('Show');
                $scope.searchResultMsg = "No data found.";
                $(".no-dataset-msg").show();
                $(".no-dataset-msg").addClass("animate");
                setTimeout(function () { $(".no-dataset-msg").removeClass("animate") }, 2000);
            }

            progressBarService.hideProgressBar();
        });
    };

    this.GetObjectData = function ($scope, compareData) {
        //$scope.UserId = $cookies.get("UserId");

        $.ajax({
            url: $scope.serviceBase + 'GetComparingObjectsData',
            async: false,
            type: "GET",
            dataType: "json",
            data: {
                DatamanagementFile: compareData
            }
        }).success(function (data) {

            for (var key in data) {

                if (data[key].objectDataSetName != "") {
                    plotDataService.addFileList(data[key].objectID);
                }

                plotDataService.addSetdata(data[key].workAreaID, data[key].spectrumID > 0 ? data[key].objectID : 0, data[key].spectrumID, data[key].technique, data[key].chemicalName, data[key].hostMaterial, data[key].spectralRegion, data[key].pubDate, data[key].dOI, data[key].objectDataSetName != "" ? data[key].objectID : "", data[key].isCurated, true);
                if (data[key].spectrumID > 0) {
                    plotDataService.addSpectrumId(data[key].objectID);
                }
                plotDataService.addChemicalname(data[key].chemicalName);
                plotDataService.addSearchString(data[key].searchStringList, data[key].spectrumID > 0 ? data[key].objectID : 0, data[key].spectrumID, data[key].workAreaID, data[key].objectDataSetName != "" ? data[key].objectID : "", true);
                plotDataService.setTechnique(data[key].objectID, data[key].technique, true);

                $scope.SetDataSetOnLoad(data[key].spectrumID > 0 ? data[key].objectID : 0, data[key].spectrumID, data[key].technique, data[key].chemicalName, data[key].hostMaterial, data[key].spectralRegion, data[key].pubDate, data[key].dOI, data[key].objectDataSetName != "" ? data[key].objectID : "", data[key].isCurated);
            }

        }).error(function (request, status, error) {
            if (error == "Not Found") {
                $scope.searchResultMsg = "No data found.";
            }
            else if (error == "Service Unavailable") {
                if ($rootScope.globalConfig.errorPage == undefined || $rootScope.globalConfig.errorPage == null || $rootScope.globalConfig.errorPage == '') {
                    $location.path("/error");
                }
                else {
                    $window.location.href = '../app/modules/error/' + $rootScope.globalConfig.errorPage;
                }
            }
            else if (error == "Internal Server Error") {
                if ($rootScope.globalConfig.errorPage == undefined || $rootScope.globalConfig.errorPage == null || $rootScope.globalConfig.errorPage == '') {
                    $location.path("/error");
                }
                else {
                    $window.location.href = '../app/modules/error/' + $rootScope.globalConfig.errorPage;
                }
            }

            console.log($scope.searchResultMsg);
        });
    };

    this.getSessionID = function ($scope) {
        //$("#searchUploadChemicals").click();
        $.ajax({
            url: $scope.serviceBase + "getNewSessionID",
            async: false,
            type: "GET",
            dataType: "json",
            data: {}
        }).success(function (data, status) {
            if (status != "204") {
                $scope.SessionUploadID = data.sessionid;
                var expireDate = new Date();
                expireDate.setDate(expireDate.getDate() + 1);
            }
        }).error(function (request, status, error) {
        });
    };

    this.getGlobalValues = function ($scope) {
        $.ajax({
            url: $scope.serviceBase + "globalValues",
            async: false,
            type: "GET",
            dataType: "json",
            data: {}
        }).success(function (data, status) {
            var expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + 1);
            $cookies.put("versionNo", data.applicationVersionNumber, { expires: expireDate });
            $cookies.put("energyRangeStart", data.searchSliderEnergyRangeStart, { expires: expireDate });
            $cookies.put("energyRangeEnd", data.searchSliderEnergyRangeEnd, { expires: expireDate });
        }).error(function (request, status, error) {
        });
    }

    this.deleteUnpublishedDataSets = function ($scope, uniqueID, filename, deleteAllRows) {
        return $http({
            method: "GET",
            url: $scope.serviceBase + "deleteFiles",
            params: {
                'uniqueID': uniqueID, 'sessionID': $scope.SessionUploadID, 'deleteAllRows': deleteAllRows
            },
            headers: {
                'Content-Type': 'application/json'
            }
        }).success(function (data, status) {
            if (status != "204") {
                if (!deleteAllRows) {
                    plotDataService.removeUnPublishedDataSet(uniqueID);
                    --$scope.unPublishedIDs;
                    if ($scope.UnPublishedDataSetCount <= 0) {
                        $(".clear-all-datasets").show();
                    }
                    $scope.$apply();
                }
                else {
                    plotDataService.clearUnPublishedDataSet();
                    $scope.unPublishedIDs = 0;
                    $scope.$apply();
                }
            }
        }).error(function (data, status) {
            if (status == "204") {
            }
        });
    };

    this.getUnpublishedFile = function ($scope) {
        return $http({
            method: "GET",
            url: $scope.serviceBase + "getFilesNames",
            params: {
                'sessionID': $scope.SessionUploadID
            },
            headers: {
                'Content-Type': 'application/json'
            }
        }).success(function (data, status) {
            if (status != "204") {
                angular.forEach(data, function (value, key) {
                    $scope.SetUnPublishedDataSetOnLoad(value.split(",")[1], value.split(",")[0]);
                });
            }
        }).error(function (data, status) {
            if (status == "204") {
            }
        });
    };

    this.saveFileName = function ($scope, uniqueID, filename) {
        //return $http({
        //    method: "GET",
        //    url: "http://localhost:58252/saveFileName",
        //    //params: { 'uniqueID': uniqueID, 'sessionID': $scope.SessionUploadID, 'fileName': filename},
        //    headers: { 'Content-Type': 'application/json' }
        //}).success(function (data) {
        //    //plotDataService.removeUnPublishedDataSet(filename);
        //    //--$scope.unPublishedIDs;
        //    //if ($scope.UnPublishedDataSetCount <= 0) {
        //    //    $(".clear-all-datasets").show();
        //    //}
        //    //$scope.$apply();
        //}).error(function (data, status) {
        //    if (status == "204") {
        //    }
        //});
        $.ajax({
            url: $scope.serviceBase + "saveFileName",
            async: true,
            type: "GET",
            dataType: "json",
            data: {
                uniqueID: uniqueID, sessionID: $scope.SessionUploadID, fileName: filename
            }
        }).success(function (data) {
        }).error(function (request, status, error) {
        });
    };

    this.getfileNameByUniqueID = function ($scope) {
        progressBarService.showProgressBar();
        return $http({
            method: "GET",
            url: $scope.serviceBase + "getfileNameByUniqueID",
            params: {
                'UniqueID': $scope.uniqueID, 'sessionID': $scope.SessionUploadID
            },
            headers: {
                'Content-Type': 'application/json'
            }
        }).success(function (data) {
            var filename = data[0];
            var fileNameWithoutExt = filename.substr(0, filename.lastIndexOf('.'));

            $('#td-data-' + $scope.uniqueID).html($('<input type="text" class="form-control input-feild-textbox" name=""  id="edit-text-' + $scope.uniqueID + '"/>').val(fileNameWithoutExt));

            $("#edit-text-" + $scope.uniqueID).focus();
            $('#edit-button-' + $scope.uniqueID).hide();
            $('#save-button-' + $scope.uniqueID).show();
            progressBarService.hideProgressBar();

        }).error(function (data, status) {
            if (status == "404") {
                $("#searchResultsContainer").removeClass("in");
                $("#viewMyDataSearchResultsContainer").removeClass("in");
                $("#viewTeamDataSearchResultsContainer").removeClass("in");
                //$(".toggle-all-row-element").fadeOut();
                $(".switch").fadeOut();
                $(".switch > input[type='checkbox']").prop('checked', false);
                $scope.searchResultMsg = "No data found.";
                $(".no-dataset-msg").show();
                $(".no-dataset-msg").addClass("animate");
                setTimeout(function () { $(".no-dataset-msg").removeClass("animate") }, 2000);
            }
            progressBarService.hideProgressBar();
        });
    };

    this.getAllSavedWorkSpace = function ($scope) {
        progressBarService.showProgressBar();
        return $http({
            method: "GET",
            url: $scope.serviceBase + "GetAllSavedWorkArea",
            //params: { AreaName: $("#txtAreatitle").val(), SavedPageNo: $scope.pagingInfo.savedPageNo, itemsPerPage: $scope.pagingInfo.itemsPerPage, SavedWorkOrderBy: $scope.pagingInfo.savedWorkSortBy, SavedWorkSortDirection: $scope.pagingInfo.savedWorkReverse, SharedPageNo: $scope.pagingInfo.sharedPageNo, SharedWorkOrderBy: $scope.pagingInfo.sharedWorkSortBy, SharedWorkSortDirection: $scope.pagingInfo.sharedWorkReverse },
            headers: {
                'Content-Type': 'application/json'
            }
        }).success(function (data, status) {
            if (status == "204") {

                progressBarService.hideProgressBar();
            }
            else {
                $scope.savedWorkspaceList = data;
                progressBarService.hideProgressBar();
            }
        }).error(function (data, status) {
            if (status == "204") {
                setTimeout(function () { $(".no-dataset-msg").removeClass("animate") }, 2000);
            }
            progressBarService.hideProgressBar();
        });
    };

}]);

app.service('searchDataService', ['$cookies', function ($cookies) {
    var currentDate = new Date();
    var energyRangeStart = parseFloat($cookies.get("energyRangeStart"));
    var energyRangeEnd = parseFloat($cookies.get("energyRangeEnd"));


    var searchResultsBackup = [];
    var viewMyDataSearchResultsBackup = [];
    var viewTeamDataSearchResultsBackup = [];

    var totalNumberRecords;
    var viewMyDataTotalNumberRecords;
    var viewTeamDataTotalNumberRecords;

    var currentPage;
    var viewMyDataCurrentPage;
    var viewTeamDataCurrentPage;

    var pagingInfo = {
        pageNo: 1,
        itemsPerPage: 10,
        sortBy: 'doi',
        reverse: true,
        keywords: '',
        chemicalName: '',
        hostMaterial: '',
        transition: '',
        element: '',
        authorLName: '',
        spectralRegion: '',
        startVal: '',
        endVal: '',
        fromDate: '',
        toDate: '',
        articleName: '',
        technique: '',
        doi: '',
        rangeApplied: false,
        currentTab: 1
    };

    var viewMyDataPagingInfo = {
        pageNo: 1,
        itemsPerPage: 10,
        sortBy: 'publicationyear',
        reverse: true
    };

    var viewTeamDataPagingInfo = {
        pageNo: 1,
        itemsPerPage: 10,
        sortBy: 'publicationyear',
        reverse: true
    };

    var collapsableRowsSwitchOn = true

    var searchTypeBasic = true;

    var pagingInfoEnegry = {
        startVal: '', endVal: '', min: '', max: '', options: {
            floor: '',
            ceil: '',
            step: 1
        }
    };

    var pagingInfoDate = {
        startVal: '', endVal: '', min: '', max: '', options: {
            floor: '',
            ceil: '',
            step: 1
        }
    };

    var showBackupData = false;

    var techniques = [];

    var objectTechniques = getLocalValue("objectTechniques");

    angular.forEach(objectTechniques, function (value, key) {
        techniques.push({
            name: value,
            selected: value.toLowerCase() == 'xps' || value.toLowerCase() == 'ups' ? true : false,
            disabled: false
        })
    });

    var selection = ['XPS', 'UPS'];

    var spectrals = [
        {
            name: 'Survey', selected: true
        },
            {
                name: 'Valence Band', selected: true
            },
{
    name: 'Transition', selected: true
},
      {
          name: 'UNSPECIFIED', selected: true
      },
    ];

    var selectionSpectral = ['Survey', 'Valence Band', 'Transition', 'UNSPECIFIED'];

    return {
        searchTypeBasic: searchTypeBasic,
        techniques: techniques,
        selection: selection,
        spectrals: spectrals,
        selectionSpectral: selectionSpectral,
        pagingInfoEnegry: pagingInfoEnegry,
        pagingInfoDate: pagingInfoDate,
        showBackupData: showBackupData,
        collapsableRowsSwitchOn: collapsableRowsSwitchOn,
        pagingInfo: pagingInfo,
        viewMyDataPagingInfo: viewMyDataPagingInfo,
        viewTeamDataPagingInfo: viewTeamDataPagingInfo
    }
}]);

app.service('plotDataService', function () {
    // Pass data to plotgraph controller

    var spectrumIdList = [];

    var objectIdList = [];

    var startendValues = ["", ""];

    var techniques = [];

    var unPublishedDataSet = [];

    var searchstringList = [];

    var chemicalnamelist = [];

    var SetdataList = [];

    var deletedObjectIDList = [];

    var deletedSearchstringList = [];

    var doiList = [];

    var fileDataSet = [];

    var addSpectrumId = function (newObj) {
        spectrumIdList.push(newObj);

    };

    var addObjectId = function (newObj) {
        objectIdList.push(newObj);

    };

    var getSpectrumIds = function () {
        return spectrumIdList;
    };

    var getObjectIds = function () {
        return objectIdList;
    };

    var removeSpectrumIds = function (newObj) {
        var index = spectrumIdList.indexOf(newObj);
        if (index > -1) {
            spectrumIdList.splice(index, 1);
        }
    };

    var removeObjectIds = function (newObj) {
        var index = objectIdList.indexOf(newObj);
        if (index > -1) {
            objectIdList.splice(index, 1);
        }
    };

    var clearSpectrumIds = function () {
        spectrumIdList.splice(0, spectrumIdList.length);
    };

    var clearObjectIds = function () {
        objectIdList.splice(0, objectIdList.length);
    };

    var addFileList = function (newObj) {
        fileDataSet.push(newObj);
    };

    var getFiles = function () {
        return fileDataSet;
    };

    var removeFiles = function (newObj) {
        var index = fileDataSet.indexOf(newObj);
        if (index > -1) {
            fileDataSet.splice(index, 1);
        }
    };

    var clearFiles = function () {
        fileDataSet.splice(0, fileDataSet.length);
    };

    var isSpectrumIdExist = function (newObj) {
        var index = spectrumIdList.indexOf(newObj);
        return index;
    };

    var isObjectIdExist = function (newObj) {
        var index = objectIdList.indexOf(newObj);
        return index;
    };

    var isFileExist = function (newObj) {
        var index = fileDataSet.indexOf(newObj);
        return index;
    };

    var setStartEndValues = function (startVal, endVal) {
        startendValues[0] = startVal;
        startendValues[1] = endVal;
    };

    var getStartEndValues = function () {
        return startendValues;
    };

    var setTechnique = function (objectid, tech, flag) {
        if (flag) {
            var index = techniques.indexOf(objectid + "-" + tech);
            if (index < 0) {
                techniques.push(objectid + "-" + tech);
            }
        }
        else {
            var index = techniques.indexOf(objectid + "-" + tech);
            if (index > -1) {
                techniques.splice(index, 1);
            }
        }
    };

    var getTechnique = function () {
        return techniques;
    };

    var clearTechnique = function () {
        techniques.splice(0, techniques.length);
    };

    var addUnPublishedDataSet = function (newObj) {
        unPublishedDataSet.push(newObj);
    };

    var getUnPublishedDataSet = function () {
        return unPublishedDataSet;
    };

    var removeUnPublishedDataSet = function (newObj) {
        var index = unPublishedDataSet.indexOf(newObj);
        if (index > -1) {
            unPublishedDataSet.splice(index, 1);
        }
    };

    var clearUnPublishedDataSet = function () {
        unPublishedDataSet.splice(0, unPublishedDataSet.length);
    };

    var addSearchString = function (searchstring, objectId, Spectrumid, workareaId, fileName, isValidFigureData, casRegistryNum, pubYear) {
        searchstringList.push({
            ObjectId: objectId, id: Spectrumid, Searchstring: searchstring, WorkareaId: workareaId, FileName: fileName, IsValidFigureData: isValidFigureData, CasRegistryNum: casRegistryNum, PubYear: pubYear
        });
    };

    var getSearchString = function () {
        return searchstringList;
    };

    var clearSearchString = function () {
        searchstringList.splice(0, searchstringList.length);
    };

    //This method will Add ChemicalName to array 
    var addChemicalname = function (newObj) {
        chemicalnamelist.push(newObj);
    };

    //This method will Fetech ChemicalName from array .
    var getChemicalNameList = function () {
        return chemicalnamelist;
    };

    var clearChemicalName = function () {
        chemicalnamelist.splice(0, chemicalnamelist.length);
    };

    var isChemicalNameExist = function (newObj) {
        var index = chemicalnamelist.indexOf(newObj);
        return index;
    };

    var addSetdata = function (workAreaID, objectId, spectrumId, technique, chemicalName, hostMaterial, spectralRegion, publicationYear, doi, fileName, isCurated, isValidFigureData, index) {
        SetdataList.push({
            WorkAreaID: workAreaID, ObjectID: objectId, SpectrumId: spectrumId, Technique: technique, ChemicalName: chemicalName, HostMaterial: hostMaterial, SpectralRegion: spectralRegion, PublicationYear: publicationYear, Doi: doi, FileName: fileName, IsCurated: isCurated, isValidFigureData: isValidFigureData, index: index
        });
    };

    var setDeletedObjectIDList = function (objectId) {
        deletedObjectIDList.push(objectId);
    }

    var getDeletedObjectIDList = function (objectId) {
        return deletedObjectIDList;
    };

    var addDeletedSearchString = function (searchStringData) {
        deletedSearchstringList.push({
            ObjectId: searchStringData.ObjectId, id: searchStringData.Spectrumid, Searchstring: searchStringData.Searchstring, WorkareaId: searchStringData.WorkareaId, FileName: searchStringData.FileName, IsValidFigureData: searchStringData.IsValidFigureData, CasRegistryNum: searchStringData.CasRegistryNum, PubYear: searchStringData.PubYear
        });
    }

    var getDeletedSearchString = function () {
        return deletedSearchstringList;
    }

    var clearDeletedSearchString = function () {
        deletedSearchstringList.splice(0, deletedSearchstringList.length);
    };

    var clearDeletedObjectIDList = function () {
        deletedObjectIDList.splice(0, deletedObjectIDList.length);
    };

    var getSetdata = function () {
        return SetdataList;
    };

    var getSpectrumId = function (spectrumId) {
        for (var i = 0; i < SetdataList.length; i++) {
            if (SetdataList[i].ObjectID == spectrumId) {
                return SetdataList[i];
            }
        }

        return null;
    };

    var getObjectId = function (objectId) {
        for (var i = 0; i < SetdataList.length; i++) {
            if (SetdataList[i].ObjectID == objectId) {
                return SetdataList[i];
            }
        }

        return null;
    };

    var getfileByName = function (file) {
        for (var i = 0; i < SetdataList.length; i++) {
            if (SetdataList[i].FileName == file) {
                return SetdataList[i];
            }
        }

        return null;
    };

    var clearDataSetDisplayString = function () {
        SetdataList.splice(0, SetdataList.length);
    };

    var removeDataSetDisplayString = function (spectrumId) {
        if (spectrumId != '') {
            var index = -1;
            for (var i = 0; i < SetdataList.length; i++) {

                if (SetdataList[i].SpectrumId == spectrumId || SetdataList[i].FileName == spectrumId || SetdataList[i].ObjectID == spectrumId) {
                    index = i;
                }
            }
            if (index > -1) {
                SetdataList.splice(index, 1);
            }
        }
    };

    var removeSearchString = function (spectrumId) {
        if (spectrumId != '') {
            var index = -1;

            if (spectrumId > 0) {
                for (var i = 0; i < searchstringList.length; i++) {
                    if (searchstringList[i].id == spectrumId || searchstringList[i].FileName == spectrumId || searchstringList[i].ObjectId == spectrumId) {
                        index = i;
                    }
                }
                if (index > -1) {
                    searchstringList.splice(index, 1);
                }
            }
        }
    };

    var getChemicalNameFromSetData = function () {
        var chemicalNames = '';
        for (var i = 0; i < SetdataList.length; i++) {
            chemicalNames += SetdataList[i].ChemicalName + ","
        }

        return chemicalNames;
    };

    return {
        addSpectrumId: addSpectrumId,
        addObjectId: addObjectId,
        getSpectrumIds: getSpectrumIds,
        getObjectIds: getObjectIds,
        getfileByName: getfileByName,
        removeSpectrumIds: removeSpectrumIds,
        removeObjectIds: removeObjectIds,
        clearSpectrumIds: clearSpectrumIds,
        clearObjectIds: clearObjectIds,
        addFileList: addFileList,
        getFiles: getFiles,
        removeFiles: removeFiles,
        clearFiles: clearFiles,
        setStartEndValues: setStartEndValues,
        getStartEndValues: getStartEndValues,
        isSpectrumIdExist: isSpectrumIdExist,
        isObjectIdExist: isObjectIdExist,
        isFileExist: isFileExist,
        setTechnique: setTechnique,
        getTechnique: getTechnique,
        clearTechnique: clearTechnique,
        addUnPublishedDataSet: addUnPublishedDataSet,
        getUnPublishedDataSet: getUnPublishedDataSet,
        removeUnPublishedDataSet: removeUnPublishedDataSet,
        clearUnPublishedDataSet: clearUnPublishedDataSet,
        addChemicalname: addChemicalname,
        getChemicalNameList: getChemicalNameList,
        addSearchString: addSearchString,
        getSearchString: getSearchString,
        clearSearchString: clearSearchString,
        isChemicalNameExist: isChemicalNameExist,
        clearChemicalName: clearChemicalName,
        addSetdata: addSetdata,
        getSpectrumId: getSpectrumId,
        getObjectId: getObjectId,
        clearDataSetDisplayString: clearDataSetDisplayString,
        removeDataSetDisplayString: removeDataSetDisplayString,
        getChemicalNameFromSetData: getChemicalNameFromSetData,
        removeSearchString: removeSearchString,
        getSetdata: getSetdata,
        setDeletedObjectIDList: setDeletedObjectIDList,
        getDeletedObjectIDList: getDeletedObjectIDList,
        clearDeletedObjectIDList: clearDeletedObjectIDList,
        addDeletedSearchString: addDeletedSearchString,
        getDeletedSearchString: getDeletedSearchString,
        clearDeletedSearchString: clearDeletedSearchString
    };

});

app.directive('dropzone', function () {
    return {
        restrict: 'C',
        link: function (scope, element, attrs) {
            scope.UploadUniqueID = null;
            var dropzone = null;
            var config = {
                url: scope.serviceBase + "upload",
                maxFilesize: 100,
                paramName: "file",
                maxThumbnailFilesize: 10,
                parallelUploads: 2,
                autoProcessQueue: true,
                method: "POST",
                //withCredentials: false,
                //parallelUploads: 2,
                //uploadMultiple: false,
                //maxFilesize: 256,
                //paramName: "uploadfile",
                //createImageThumbnails: true,
                //maxThumbnailFilesize: 10,
                //thumbnailWidth: 120,
                //thumbnailHeight: 120,
                //filesizeBase: 1000,
                //maxFiles: null,
                params: {
                    'SessionID': scope.SessionUploadID
                },//["sessionIDTest"],
                //clickable: true,
                //ignoreHiddenFiles: true,
                acceptedFiles: ".tsv,text/tab-separated-values,text/plain,.csv, application/text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                //acceptedMimeTypes: null,
                //autoProcessQueue: true,
                //autoQueue: true,
                //addRemoveLinks: true,
                //previewsContainer: null,
                //hiddenInputContainer: "body",
                //capture: null,
                //renameFilename: null,
                //dictDefaultMessage: "Drop spectra data files(in tab delimited format) here or click to upload",
                //dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
                //dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
                //dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
                //dictInvalidFileType: "You can't upload files of this type.",
                //dictResponseError: "Server responded with {{statusCode}} code.",
                //dictCancelUpload: "Cancel upload",
                //dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
                //dictRemoveFile: "Remove file",
                //dictRemoveFileConfirmation: null,
                //dictMaxFilesExceeded: "You can not upload any more files."
            };

            var eventHandlers = {
                'addedfile': function (file, response, data) {
                    if (file.type == "text/plain" || file.type == "application/vnd.ms-excel" || file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.name.indexOf(".tsv") > -1) {
                        scope.file = file;
                        //if (this.files[1] != null) {
                        //    this.removeFile(this.files[0]);
                        //}
                        scope.$apply(function () {
                            scope.fileAdded = true;
                        });
                    }
                    else {
                        alert("Invalid file format. Please consult the user documentation");
                    }
                },
                'success': function (file, response, data) {
                    if (data.target.status == "200") {

                        scope.SetUnPublishedDataSet(file.name, response.fileName);
                    }
                },
                'error': function (file, response, data) {
                    if (data.status == "400") {
                        alert("Invalid file format. Please consult the user documentation. File Name : " + file.name);
                    }
                }
            };

            dropzone = new Dropzone(element[0], config);

            angular.forEach(eventHandlers, function (handler, event) {
                dropzone.on(event, handler);
            });

            scope.processDropzone = function () {
                dropzone.processQueue();
            };

            scope.resetDropzone = function () {
                dropzone.removeAllFiles();
            }
        }
    }
});

app.controller('redirectcontroller', ['$scope', '$location', '$http', '$cookies', 'searchservice', 'plotDataService', 'progressBarService', '$compile', '$rootScope', '$timeout', function ($scope, $location, $http, $cookies, searchservice, plotDataService, progressBarService, $compile, $rootScope, $timeout) {
    $scope.redirectToPlotGraph = function (path) {
        $timeout(function () {
            progressBarService.showProgressBar();
            $timeout(function () {
                $location.path(path);
            }, 500);
        }, 0);
    }
}]);

app.directive('onSearchResultsFinishRender', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$last === true) {
                $timeout(function () {
                    scope.$emit(attr.broadcasteventname ? attr.broadcasteventname : 'ngRepeatFinished');
                });
            }
        }
    }
});